// @generated from semantic profiles — do not edit manually
// Regenerate: npx tsx scripts/generate-nearley-grammar.ts
// Source: packages/semantic/src/generators/profiles/*.ts

/**
 * Keyword → language(s) lookup table for language detection.
 * Generated from 24 semantic language profiles.
 *
 * Used by the Nearley-based language detector (Phase 5.1).
 * Each keyword maps to the language(s) that use it as a command keyword.
 */
export const KEYWORD_LANGUAGE_MAP: Record<string, readonly string[]> = {
  '-kama': ['qu'],
  '-manta': ['qu'],
  a: ['es', 'pt', 'it', 'tr'],
  à: ['fr'],
  'a menos que': ['es'],
  a_menos: ['pt'],
  abfangen: ['de'],
  abrir: ['es', 'pt'],
  abrufen: ['de'],
  absenden: ['de'],
  ac: ['tr'],
  aç: ['tr'],
  'aç/kapat': ['tr'],
  accodare: ['it'],
  acha: ['sw'],
  acrescentar: ['pt'],
  activar: ['es'],
  adalah: ['ms'],
  add: ['en'],
  además: ['es'],
  adentro: ['es'],
  adicionar: ['pt'],
  afficher: ['fr'],
  after: ['en'],
  aggiungere: ['it'],
  aggiungi: ['it'],
  agos: ['tl'],
  agregar: ['es'],
  aguardar: ['pt'],
  ajouter: ['fr'],
  ajukan: ['id'],
  akhir: ['id'],
  akış: ['tr'],
  akıt: ['tr'],
  akllay: ['qu'],
  al: ['es', 'it', 'tr'],
  alama: ['sw'],
  'além disso': ['pt'],
  alihkan: ['id'],
  aliran: ['ms'],
  alirkan: ['id'],
  alisin: ['tl'],
  alisin_tuon: ['tl'],
  'alisin-laman': ['tl'],
  aller: ['fr'],
  allora: ['it'],
  alors: ['fr'],
  alteração: ['pt'],
  alternar: ['es', 'pt'],
  alternare: ['it'],
  alterner: ['fr'],
  altrimenti: ['it'],
  ambatanisha: ['sw'],
  ambatisha: ['sw'],
  ambia: ['sw'],
  ambil: ['id', 'ms'],
  ambil_dari: ['ms'],
  ẩn: ['vi'],
  añadir: ['es'],
  anche: ['it'],
  anchuchiy: ['qu'],
  and: ['en'],
  andare: ['it'],
  ändern: ['de'],
  ändert: ['de'],
  änderung: ['de'],
  andika: ['sw'],
  anexar: ['es', 'pt'],
  angazia: ['sw'],
  anhalten: ['de'],
  anhängen: ['de'],
  animar: ['es', 'pt'],
  animare: ['it'],
  animasikan: ['id'],
  animer: ['fr'],
  animieren: ['de'],
  animisha: ['sw'],
  animuj: ['pl'],
  annexer: ['fr'],
  anschließend: ['de'],
  ansonsten: ['de'],
  anteponer: ['es'],
  anteporre: ['it'],
  anterior: ['es'],
  antes: ['es', 'pt'],
  'antes de': ['es'],
  anza: ['sw'],
  anzeigen: ['de'],
  anzisha: ['sw'],
  'anzisha-upya': ['sw'],
  ao: ['pt'],
  'ao-vivo': ['pt'],
  apabila: ['ms'],
  apachiy: ['qu'],
  apagar: ['pt'],
  apakuy: ['qu'],
  apamuy: ['qu'],
  apaykachay: ['qu'],
  apitar: ['pt'],
  appeler: ['fr'],
  append: ['en'],
  après: ['fr'],
  aprire: ['it'],
  arahkan: ['id'],
  'araya-gir': ['tr'],
  arbeiter: ['de'],
  ardindan: ['tr'],
  ardından: ['tr'],
  arrêter: ['fr'],
  arrojar: ['es'],
  artır: ['tr'],
  as: ['en'],
  asenkron: ['tr'],
  asincrono: ['es', 'it'],
  asíncrono: ['es'],
  asinkron: ['id'],
  aspettare: ['it'],
  assíncrono: ['pt'],
  async: ['en', 'ru', 'pl', 'uk', 'tl'],
  asynchron: ['de'],
  asynchrone: ['fr'],
  asynchronicznie: ['pl'],
  at: ['tl'],
  até: ['pt'],
  ativar: ['pt'],
  attendere: ['it'],
  attendre: ['fr'],
  attivare: ['it'],
  atur: ['id'],
  au: ['fr'],
  auch: ['de'],
  aucun: ['fr'],
  auf: ['de'],
  aufrufen: ['de'],
  augmenter: ['fr'],
  aumentar: ['es', 'pt'],
  aumentare: ['it'],
  aus: ['de'],
  ausgeben: ['de'],
  auslösen: ['de'],
  aussi: ['fr'],
  austauschen: ['de'],
  auswählen: ['de'],
  avant: ['fr'],
  avec: ['fr'],
  awali: ['id'],
  ay: ['tl'],
  ayarla: ['tr'],
  ayrıca: ['tr'],
  az: ['pl'],
  aż: ['pl'],
  azalt: ['tr'],
  baada: ['sw'],
  baadaye: ['sw'],
  badalisha: ['sw'],
  badili_url: ['sw'],
  badilisha: ['sw'],
  'badilisha umbo': ['sw'],
  badilisha_url: ['sw'],
  badilishana: ['sw'],
  bağla: ['tr'],
  bağlan: ['tr'],
  bağlantı: ['tr'],
  bago: ['tl'],
  baguhin: ['tl'],
  bấm: ['vi'],
  basculer: ['fr'],
  başınaekle: ['tr'],
  başlat: ['tr'],
  'bất đồng bộ': ['vi'],
  'bật tắt': ['vi'],
  bawaan: ['id'],
  bawasan: ['tl'],
  beenden: ['de'],
  beep: ['en', 'it', 'vi'],
  before: ['en'],
  behavior: ['en'],
  bei: ['de'],
  bekle: ['tr'],
  bekommen: ['de'],
  belirle: ['tr'],
  bereinigen: ['de'],
  berhenti: ['id', 'ms'],
  beritahu: ['id', 'ms'],
  bersihkan: ['id', 'ms'],
  berubah: ['id', 'ms'],
  'biến đổi': ['vi'],
  bikin: ['id'],
  bila: ['id', 'ms'],
  bind: [
    'en',
    'es',
    'pt',
    'fr',
    'de',
    'it',
    'ja',
    'zh',
    'ko',
    'ar',
    'tr',
    'id',
    'ru',
    'hi',
    'bn',
    'th',
    'vi',
    'pl',
    'uk',
    'sw',
    'qu',
    'he',
    'ms',
    'tl',
  ],
  binden: ['de'],
  bip: ['fr', 'tr'],
  bis: ['de'],
  bitiş: ['tr'],
  bitti: ['tr'],
  blur: ['en', 'id', 'sw'],
  bỏ: ['vi'],
  'bổ sung': ['vi'],
  borrar: ['es'],
  boş: ['tr'],
  bosalt: ['tr'],
  boşalt: ['tr'],
  brak: ['pl'],
  break: ['en'],
  breakpoint: ['en', 'he', 'tl'],
  buang: ['id', 'ms'],
  buat: ['id', 'ms'],
  buka: ['id', 'ms'],
  buksan: ['tl'],
  bulanik: ['tr'],
  bulanık: ['tr'],
  bulanıklık: ['tr'],
  bumalik: ['tl'],
  bunyi: ['id', 'ms'],
  burahin: ['tl'],
  buscar: ['es', 'pt'],
  busque: ['pt'],
  by: ['en'],
  cacher: ['fr'],
  çağır: ['tr'],
  'cài đặt': ['vi'],
  call: ['en'],
  cambia: ['es', 'it'],
  cambiamento: ['it'],
  cambiar: ['es'],
  cambio: ['es', 'it'],
  'cambio de tamano': ['es'],
  'cambio de tamaño': ['es'],
  cancellare: ['it'],
  canlı: ['tr'],
  carga: ['es'],
  cargar: ['es'],
  carica: ['it'],
  caricamento: ['it'],
  catat: ['id', 'ms'],
  cegat: ['id', 'ms'],
  cercano: ['es'],
  cerrar: ['es'],
  cetak: ['id'],
  cetuskan: ['ms'],
  "ch'uquchiy": ['qu'],
  "ch'usaq": ['qu'],
  chagua: ['sw'],
  'chaguo-msingi': ['sw'],
  chamar: ['pt'],
  chặn: ['vi'],
  'chặn bắt': ['vi'],
  changanua: ['sw'],
  change: ['fr'],
  changement: ['fr'],
  changer: ['fr'],
  changes: ['en'],
  chanqay: ['qu'],
  'chanzo-matukio': ['sw'],
  chargement: ['fr'],
  charger: ['fr'],
  chaymanta: ['qu'],
  chaymantataq: ['qu'],
  chaymantawan: ['qu'],
  chaypim: ['qu'],
  che: ['vi'],
  chercher: ['fr'],
  chiamare: ['it'],
  chiudere: ['it'],
  cho: ['vi'],
  chờ: ['vi'],
  'cho đến khi': ['vi'],
  'chờ đợi': ['vi'],
  chochea: ['sw'],
  choisir: ['fr'],
  chọn: ['vi'],
  chora: ['sw'],
  chukua: ['sw'],
  churanay: ['qu'],
  churay: ['qu'],
  chusaq: ['qu'],
  chuyển: ['vi'],
  'chuyển đổi': ['vi'],
  'chuyển tiếp': ['vi'],
  chyba: ['pl'],
  cipta: ['ms'],
  ciptakan: ['id'],
  çık: ['tr'],
  clear: ['en'],
  clic: ['es', 'fr', 'it'],
  clicar: ['pt'],
  clicca: ['it'],
  click: ['es'],
  clique: ['pt', 'fr'],
  clonar: ['es', 'pt'],
  clonare: ['it'],
  clone: ['en'],
  cloner: ['fr'],
  close: ['en'],
  cocok: ['id'],
  coincide: ['es'],
  collegare: ['it'],
  colocar: ['es', 'pt'],
  coloque: ['pt'],
  com: ['pt'],
  commutare: ['it'],
  comportamento: ['pt', 'it'],
  comportamiento: ['es'],
  comportement: ['fr'],
  con: ['es', 'it'],
  concentrer: ['fr'],
  conectar: ['es', 'pt'],
  conectarse: ['es'],
  conexão: ['pt'],
  configurar: ['pt'],
  'công nhân': ['vi'],
  conmutar: ['es'],
  connect: ['en', 'tl'],
  connecter: ['fr'],
  connettere: ['it'],
  connettersi: ['it'],
  connexion: ['fr'],
  conseguir: ['es'],
  continuar: ['es', 'pt'],
  continuare: ['it'],
  continue: ['en'],
  continuer: ['fr'],
  converter: ['pt'],
  convertir: ['es'],
  convertire: ['it'],
  copiar: ['es', 'pt'],
  copiare: ['it'],
  copier: ['fr'],
  copy: ['en'],
  correspond: ['fr'],
  corresponde: ['pt'],
  corrisponde: ['it'],
  crear: ['es'],
  creare: ['it'],
  créer: ['fr'],
  criar: ['pt'],
  cuando: ['es'],
  cuộn: ['vi'],
  czekaj: ['pl'],
  da: ['it', 'tr'],
  dagdagan: ['tl'],
  'daha sonra': ['tr'],
  'dal-vivo': ['it'],
  dalej: ['pl'],
  dan: ['tr', 'id', 'ms'],
  danach: ['de'],
  'đánh-dấu': ['vi'],
  dann: ['de'],
  dans: ['fr'],
  dapatkan: ['id', 'ms'],
  dari: ['id', 'ms'],
  đặt: ['vi'],
  'đặt-lại': ['vi'],
  davranış: ['tr'],
  đẩy: ['vi'],
  de: ['es', 'pt', 'fr', 'tr'],
  để: ['vi'],
  'de lo contrario': ['es'],
  decir: ['es'],
  déclencher: ['fr'],
  decrement: ['en'],
  decrementar: ['es', 'pt'],
  decrementare: ['it'],
  décrémenter: ['fr'],
  default: ['en', 'tl'],
  défaut: ['fr'],
  defilement: ['fr'],
  défilement: ['fr'],
  défiler: ['fr'],
  defina: ['pt'],
  definieren: ['de'],
  definir: ['es', 'pt'],
  définir: ['fr'],
  definire: ['it'],
  défocaliser: ['fr'],
  defokussieren: ['de'],
  degil: ['tr'],
  değil: ['tr'],
  değilse: ['tr'],
  değişiklik: ['tr'],
  degisim: ['tr'],
  değişim: ['tr'],
  değiştiğinde: ['tr'],
  değiştir: ['tr'],
  degistir_url: ['tr'],
  değiştir_url: ['tr'],
  den: ['tr'],
  đến: ['vi'],
  dengan: ['id', 'ms'],
  dentro: ['es', 'pt', 'it'],
  'dentro de': ['es', 'pt'],
  depois: ['pt'],
  depuis: ['fr'],
  desde: ['es', 'pt'],
  desenfocar: ['es'],
  desenfoque: ['es'],
  desfocar: ['pt'],
  deslocamento: ['pt'],
  desplazamiento: ['es'],
  desplazar: ['es'],
  despues: ['es'],
  después: ['es'],
  'despues de': ['es'],
  'después de': ['es'],
  detener: ['es'],
  devam: ['tr'],
  devolver: ['es', 'pt'],
  di: ['it', 'id'],
  đi: ['vi'],
  'di chuột': ['vi'],
  'đi đến': ['vi'],
  di_mana: ['id', 'ms'],
  'điểm-dừng': ['vi'],
  diminuer: ['fr'],
  diminuir: ['pt'],
  diminuire: ['it'],
  dir: ['tr'],
  dire: ['fr', 'it'],
  direct: ['fr'],
  directo: ['es'],
  direkt: ['de'],
  direkta: ['tl'],
  direto: ['pt'],
  diretta: ['it'],
  disminuir: ['es'],
  disparar: ['es', 'pt'],
  dizer: ['pt'],
  dla: ['pl'],
  do: ['pl'],
  'đo lường': ['vi'],
  dodaj: ['pl'],
  đổi: ['vi'],
  đợi: ['vi'],
  dolacz: ['pl'],
  dołącz: ['pl'],
  domyslnie: ['pl'],
  domyślnie: ['pl'],
  dön: ['tr'],
  donde: ['es'],
  đóng: ['vi'],
  dönüştür: ['tr'],
  dopo: ['it'],
  dopoki: ['pl'],
  dopóki: ['pl'],
  dorong: ['id'],
  dove: ['it'],
  drücken: ['de'],
  đưa: ['vi'],
  dừng: ['vi'],
  'dừng lại': ['vi'],
  duplicar: ['es'],
  dupliquer: ['fr'],
  duplizieren: ['de'],
  dur: ['tr'],
  durdur: ['tr'],
  durumunda: ['tr'],
  e: ['pt', 'it', 'tr'],
  é: ['pt'],
  échanger: ['fr'],
  echtzeit: ['de'],
  effacer: ['fr'],
  également: ['fr'],
  eğer: ['tr'],
  eingabe: ['de'],
  ekle: ['tr'],
  elaborare: ['it'],
  elekea: ['sw'],
  eliminar: ['es', 'pt'],
  eliminare: ['it'],
  else: ['en'],
  em: ['pt'],
  empty: ['en'],
  empujar: ['es'],
  empurrar: ['pt'],
  en: ['es'],
  'en-direct': ['fr'],
  'en-vivo': ['es'],
  end: ['en'],
  enda: ['sw'],
  ende: ['de'],
  endelea: ['sw'],
  enfocar: ['es'],
  enfoque: ['es'],
  enlazar: ['es'],
  enlever: ['fr'],
  enquanto: ['pt'],
  enregistrer: ['fr'],
  enseñar: ['es'],
  ensuite: ['fr'],
  então: ['pt'],
  entfernen: ['de'],
  entfokussieren: ['de'],
  entonces: ['es'],
  entrada: ['es', 'pt'],
  entrée: ['fr'],
  envía: ['es'],
  enviar: ['es', 'pt'],
  envio: ['es', 'pt'],
  envío: ['es'],
  envoie: ['fr'],
  envoyer: ['fr'],
  ereignis: ['de'],
  ereignisquelle: ['de'],
  erhalten: ['de'],
  erhöhen: ['de'],
  ersetzen: ['de'],
  erstellen: ['de'],
  erzeugen: ['de'],
  es: ['es'],
  escoger: ['es'],
  escolher: ['pt'],
  esconda: ['pt'],
  esconder: ['es', 'pt'],
  eşleşir: ['tr'],
  esperar: ['es', 'pt'],
  est: ['fr'],
  estabilizar: ['es', 'pt'],
  establece: ['es'],
  establecer: ['es'],
  esvaziar: ['pt'],
  et: ['fr'],
  établir: ['fr'],
  événement: ['fr'],
  event: ['en', 'de', 'id'],
  evento: ['es', 'pt', 'it'],
  eventsource: [
    'en',
    'es',
    'pt',
    'fr',
    'de',
    'it',
    'ja',
    'zh',
    'ko',
    'ar',
    'tr',
    'id',
    'ru',
    'hi',
    'bn',
    'th',
    'vi',
    'pl',
    'uk',
    'sw',
    'qu',
    'he',
    'ms',
    'tl',
  ],
  exibir: ['pt'],
  existe: ['es', 'pt', 'fr'],
  existiert: ['de'],
  exit: ['en'],
  faire: ['fr'],
  'faire-défiler': ['fr'],
  falls: ['de'],
  fare: ['it'],
  fazer: ['pt'],
  fechar: ['pt'],
  fermare: ['it'],
  fermer: ['fr'],
  fertig: ['de'],
  festlegen: ['de'],
  fetch: ['en'],
  ficha: ['sw'],
  fijar: ['es'],
  fim: ['pt'],
  fin: ['es', 'fr'],
  final: ['es', 'pt'],
  fine: ['it'],
  finir: ['fr'],
  fino: ['it'],
  fırlat: ['tr'],
  flujo: ['es'],
  flusso: ['it'],
  flux: ['fr'],
  fluxo: ['pt'],
  focaliser: ['fr'],
  focalizzare: ['it'],
  focar: ['pt'],
  foco: ['pt'],
  focus: ['en'],
  fokus: ['de', 'id', 'ms'],
  fokuserhalt: ['de'],
  fokuskan: ['id'],
  fokussieren: ['de'],
  fokusverlust: ['de'],
  'fonte-de-eventos': ['pt'],
  for: ['en'],
  forever: [
    'es',
    'pt',
    'fr',
    'de',
    'it',
    'ja',
    'zh',
    'ko',
    'ar',
    'tr',
    'id',
    'ru',
    'hi',
    'bn',
    'th',
    'vi',
    'pl',
    'uk',
    'sw',
    'qu',
    'he',
    'ms',
    'tl',
  ],
  fortfahren: ['de'],
  from: ['en'],
  'fuente-de-eventos': ['es'],
  fuera: ['es'],
  'fuera de': ['es'],
  funga: ['sw'],
  funganisha: ['sw'],
  fungua: ['sw'],
  für: ['de'],
  futa: ['sw'],
  galing: ['tl'],
  gán: ['vi'],
  ganti: ['id'],
  ganti_url: ['id', 'ms'],
  gantikan_url: ['id', 'ms'],
  gdy: ['pl'],
  gdzie: ['pl'],
  geçiş: ['tr'],
  gehen: ['de'],
  'gerçek-zamanlı': ['tr'],
  get: ['en'],
  getir: ['tr'],
  geuza: ['sw'],
  giảm: ['vi'],
  'giảm đi': ['vi'],
  giấu: ['vi'],
  girdi: ['tr'],
  giris: ['tr'],
  giriş: ['tr'],
  git: ['tr'],
  gizle: ['tr'],
  gniazdo: ['pl'],
  go: ['en'],
  'gỡ bỏ': ['vi'],
  gọi: ['vi'],
  gönder: ['tr'],
  gönderme: ['tr'],
  göster: ['tr'],
  'größe ändern': ['de'],
  größeändern: ['de'],
  grössenänderung: ['de'],
  größenänderung: ['de'],
  gửi: ['vi'],
  gulir: ['id'],
  gulung: ['id'],
  gumawa: ['tl'],
  habang: ['tl'],
  habis: ['ms'],
  hacer: ['es'],
  'hacer clic': ['es'],
  hacia: ['es'],
  hadi: ['sw'],
  hai: ['sw'],
  hakuna: ['sw'],
  halafu: ['sw'],
  halt: ['en'],
  haltepunkt: ['de'],
  hamisha: ['sw'],
  hanggang: ['tl'],
  'hành vi': ['vi'],
  hantar: ['ms'],
  hapiy: ['qu'],
  hapus: ['id'],
  harangin: ['tl'],
  "hark'ay": ['qu'],
  hasta: ['es'],
  'hasta que': ['es'],
  hawachiy: ['qu'],
  'hem de': ['tr'],
  henti: ['ms'],
  hentikan: ['id'],
  hide: ['en'],
  hiện: ['vi'],
  'hiển thị': ['vi'],
  hilangkan: ['id'],
  hinallataq: ['qu'],
  hinaspa: ['qu'],
  hinein: ['de'],
  hintay: ['tl'],
  hinzufügen: ['de'],
  'hoán đổi': ['vi'],
  holen: ['de'],
  hover: ['de', 'id', 'pl'],
  hubungkan: ['id', 'ms'],
  hukllachay: ['qu'],
  hukniraq: ['qu'],
  humarang: ['tl'],
  huminto: ['tl'],
  hurquy: ['qu'],
  i: ['tr', 'pl'],
  'i-clone': ['tl'],
  'i-reset': ['tl'],
  'i-stream': ['tl'],
  ibaba: ['tl'],
  ibalik: ['tl'],
  için: ['tr'],
  içine: ['tr'],
  idagdag: ['tl'],
  idagdag_sa_dulo: ['tl'],
  idagdag_sa_simula: ['tl'],
  idz: ['pl'],
  idź: ['pl'],
  if: ['en'],
  ihagis: ['tl'],
  ikabit: ['tl'],
  ikat: ['id', 'ms'],
  iken: ['tr'],
  ikiwa: ['sw'],
  ikonekta: ['tl'],
  ilagay: ['tl'],
  ile: ['tr'],
  iliştir: ['tr'],
  ima: ['qu'],
  imarika: ['sw'],
  imayna: ['qu'],
  impostare: ['it'],
  imprimir: ['es', 'pt'],
  in: ['de', 'it', 'tr'],
  'in ra': ['vi'],
  'in-diretta': ['it'],
  inabadilika: ['sw'],
  inaczej: ['pl'],
  inafanana: ['sw'],
  increment: ['en'],
  incrementar: ['es', 'pt'],
  incrementare: ['it'],
  incrémenter: ['fr'],
  inicialização: ['pt'],
  inicialización: ['es'],
  inicializar: ['es', 'pt'],
  iniciar: ['es', 'pt'],
  inicio: ['es'],
  inicjuj: ['pl'],
  inisialisasi: ['id'],
  init: ['en'],
  initialiser: ['fr'],
  initialisieren: ['de'],
  initialisierung: ['de'],
  inizia: ['it'],
  inizializzare: ['it'],
  input: ['it', 'id', 'pl'],
  inserção: ['pt'],
  inserimento: ['it'],
  inserire: ['it'],
  instal: ['id'],
  instalar: ['es', 'pt'],
  install: ['en'],
  installare: ['it'],
  installer: ['fr'],
  installieren: ['de'],
  intercambiar: ['es'],
  intercept: [
    'en',
    'es',
    'pt',
    'fr',
    'de',
    'it',
    'ja',
    'zh',
    'ko',
    'ar',
    'tr',
    'id',
    'ru',
    'hi',
    'bn',
    'th',
    'vi',
    'pl',
    'uk',
    'sw',
    'qu',
    'he',
    'ms',
    'tl',
  ],
  interceptar: ['es', 'pt'],
  intercepter: ['fr'],
  intercettare: ['it'],
  interromper: ['pt'],
  interrompere: ['it'],
  interrompre: ['fr'],
  into: ['en'],
  introducir: ['es'],
  inviare: ['it'],
  invio: ['it'],
  ipadala: ['tl'],
  ipakita: ['tl'],
  iproseso: ['tl'],
  ipush: ['tl'],
  ir: ['es', 'pt'],
  irender: ['tl'],
  ireplace: ['tl'],
  isara: ['tl'],
  işçi: ['tr'],
  iscroll: ['tl'],
  isipokuwa: ['sw'],
  'isiyo sawia': ['sw'],
  isle: ['tr'],
  işle: ['tr'],
  ist: ['de'],
  ita: ['sw'],
  itago: ['tl'],
  itakda: ['tl'],
  itala: ['tl'],
  itali: ['tl'],
  itapon: ['tl'],
  itele: ['tr'],
  itigil: ['tl'],
  itoggle: ['tl'],
  itulak: ['tl'],
  ituon: ['tl'],
  iugnay: ['tl'],
  ı: ['tr'],
  ın: ['tr'],
  jalankan: ['id'],
  javascript: ['de', 'id', 'sw'],
  jesli: ['pl'],
  jeśli: ['pl'],
  jezeli: ['pl'],
  jeżeli: ['pl'],
  jika: ['id', 'ms'],
  jika_tidak: ['ms'],
  journaliser: ['fr'],
  js: [
    'en',
    'es',
    'pt',
    'fr',
    'de',
    'it',
    'ja',
    'zh',
    'ko',
    'ar',
    'tr',
    'id',
    'ru',
    'hi',
    'bn',
    'th',
    'vi',
    'pl',
    'uk',
    'sw',
    'qu',
    'he',
    'ms',
    'tl',
  ],
  js실행: ['ko'],
  js実行: ['ja'],
  js执行: ['zh'],
  juga: ['id'],
  "jusqu'à": ['fr'],
  jusque: ['fr'],
  kabla: ['sw'],
  kabur: ['ms'],
  kachay: ['qu'],
  kadar: ['tr'],
  kadri: ['sw'],
  kaitkan: ['id', 'ms'],
  kalau: ['id', 'ms'],
  kalau_tidak: ['ms'],
  kaldır: ['tr'],
  kama: ['sw', 'qu'],
  kamay: ['qu'],
  kamaykuy: ['qu'],
  kambiay: ['qu'],
  kanqa: ['qu'],
  kapag: ['tl'],
  kapat: ['tr'],
  katakan: ['id'],
  kawsachkaq: ['qu'],
  kawsay: ['qu'],
  'kawsay-pukyu': ['qu'],
  kaydet: ['tr'],
  kaydir: ['tr'],
  kaydirma: ['tr'],
  kaydır: ['tr'],
  kaydırma: ['tr'],
  kaykamaqa: ['qu'],
  kaypi: ['qu'],
  kazdy: ['pl'],
  każdy: ['pl'],
  ke: ['id', 'ms'],
  'ke dalam': ['id'],
  ke_dalam: ['ms'],
  kecuali: ['id', 'ms'],
  kein: ['de'],
  kelakuan: ['ms'],
  keluar: ['id', 'ms'],
  kembali: ['id', 'ms'],
  kembalikan: ['id'],
  kemudian: ['id', 'ms'],
  'kesme-noktasi': ['tr'],
  'kesme-noktası': ['tr'],
  'kết thúc': ['vi'],
  'kết xuất': ['vi'],
  'kết-nối': ['vi'],
  'kết-nối-tới': ['vi'],
  ketika: ['id', 'ms'],
  khi: ['vi'],
  khỏi: ['vi'],
  'khởi tạo': ['vi'],
  'không thì': ['vi'],
  khớp: ['vi'],
  'kích hoạt': ['vi'],
  kichay: ['qu'],
  kiedy: ['pl'],
  kikinchay: ['qu'],
  kilos: ['tl'],
  kirim: ['id'],
  kirimkan: ['id'],
  kisha: ['sw'],
  klick: ['de'],
  klicken: ['de'],
  klik: ['id', 'pl'],
  klikniecie: ['pl'],
  kliknięciu: ['pl'],
  klon: ['id', 'ms'],
  klonen: ['de'],
  klonla: ['tr'],
  koneksi: ['id'],
  koniec: ['pl'],
  kontynuuj: ['pl'],
  kopieren: ['de'],
  kopiuj: ['pl'],
  kopyahin: ['tl'],
  kopyala: ['tr'],
  kosong: ['id', 'ms'],
  kosongkan: ['id', 'ms'],
  koy: ['tr'],
  kuhanin_mula: ['tl'],
  kumonekta: ['tl'],
  kumuha: ['tl'],
  'kunan-pacha': ['qu'],
  kundi: ['tl'],
  kung: ['tl'],
  kung_hindi: ['tl'],
  kung_saan: ['tl'],
  kunin: ['tl'],
  kunin_mula: ['tl'],
  kunray: ['qu'],
  kur: ['tr'],
  kurang_satu: ['ms'],
  kurangi: ['id'],
  kutichiy: ['qu'],
  kutimuy: ['qu'],
  kutipay: ['qu'],
  kutoka: ['sw'],
  kuyuchiy: ['qu'],
  kwa: ['sw'],
  kwenye: ['sw'],
  la: ['tr'],
  laden: ['de'],
  lainnya: ['id'],
  lalai: ['ms'],
  lalu: ['id'],
  'làm-rỗng': ['vi'],
  lançar: ['pt'],
  lancer: ['fr'],
  lanciare: ['it'],
  langsung: ['id', 'ms'],
  lanjutkan: ['id'],
  lanzar: ['es'],
  'lặp lại': ['vi'],
  lavoratore: ['it'],
  lấy: ['vi'],
  'lấy giá trị': ['vi'],
  le: ['tr'],
  leer: ['de'],
  leeren: ['de'],
  legare: ['it'],
  lempar: ['id', 'ms'],
  lenga: ['sw'],
  lepas: ['ms'],
  lepas_itu: ['ms'],
  leta: ['sw'],
  letak: ['ms'],
  letakkan: ['id', 'ms'],
  lia: ['sw'],
  'liên kết': ['vi'],
  lier: ['fr'],
  ligar: ['pt'],
  limpar: ['pt'],
  limpiar: ['es'],
  live: ['en', 'de', 'id', 'vi', 'pl', 'tl'],
  llamar: ['es'],
  "llamk'aq": ['qu'],
  lluqsiy: ['qu'],
  'loại bỏ': ['vi'],
  log: ['en', 'ms'],
  logo: ['pt'],
  loguj: ['pl'],
  lors: ['fr'],
  löschen: ['de'],
  lúc: ['vi'],
  luego: ['es'],
  lumabas: ['tl'],
  lumikha: ['tl'],
  lumipat: ['tl'],
  luồng: ['vi'],
  'mặc định': ['vi'],
  machen: ['de'],
  mag_scroll: ['tl'],
  'mag-install': ['tl'],
  magdagdag: ['tl'],
  maghintay: ['tl'],
  maglagay: ['tl'],
  magpadala: ['tl'],
  magpakailanman: ['tl'],
  magpakita: ['tl'],
  magpalit: ['tl'],
  magpatahimik: ['tl'],
  magpatugtog: ['tl'],
  magpatuloy: ['tl'],
  magsabi: ['tl'],
  magsimula: ['tl'],
  magtago: ['tl'],
  magtakda: ['tl'],
  'mãi mãi': ['vi'],
  make: ['en'],
  maliban_kung: ['tl'],
  maliza: ['sw'],
  man: ['qu'],
  'mana qhawachiy': ['qu'],
  'mana sichus': ['qu'],
  'mana waqtalla': ['qu'],
  manachus: ['qu'],
  manggagawa: ['tl'],
  manta: ['qu'],
  marcay: ['qu'],
  markieren: ['de'],
  masquer: ['fr'],
  masuk: ['id'],
  masukan: ['id'],
  masukkan: ['id'],
  'mất tập trung': ['vi'],
  matapos: ['tl'],
  maykama: ['qu'],
  maypi: ['qu'],
  measure: ['en'],
  medir: ['es', 'pt'],
  menos: ['es'],
  mentre: ['it'],
  messen: ['de'],
  mesurer: ['fr'],
  métamorphoser: ['fr'],
  mets: ['fr'],
  mettere: ['it'],
  mettre: ['fr'],
  mfanyakazi: ['sw'],
  mficho: ['sw'],
  mientras: ['es'],
  misurare: ['it'],
  mit: ['de'],
  mở: ['vi'],
  modifier: ['fr'],
  'moja-kwa-moja': ['sw'],
  montre: ['fr'],
  montrer: ['fr'],
  morph: ['en'],
  mostrar: ['es', 'pt'],
  mostrare: ['it'],
  'mouse baixo': ['pt'],
  'mouse cima': ['pt'],
  'mouse encima': ['es'],
  'mouse fuera': ['es'],
  'mouse liberado': ['pt'],
  'mouse presionado': ['es'],
  'mouse pressionado': ['pt'],
  'mouse soltado': ['es'],
  'mouse solto': ['pt'],
  mousebaixo: ['pt'],
  mousecima: ['pt'],
  mpito: ['sw'],
  msingi: ['sw'],
  mtiririko: ['sw'],
  muat: ['id', 'ms'],
  mubashara: ['sw'],
  muda: ['pt'],
  mudança: ['pt'],
  muestra: ['es'],
  mula: ['ms', 'tl'],
  mula_sa: ['tl'],
  mulai: ['id'],
  mulakan: ['ms'],
  musuqchay: ['qu'],
  muyu: ['qu'],
  mwaga: ['sw'],
  mwisho: ['sw'],
  na: ['tr', 'pl', 'sw'],
  'na-bieżąco': ['pl'],
  'na-żywo': ['pl'],
  nach: ['de'],
  nadpisz: ['pl'],
  nagbabago: ['tl'],
  naikkan: ['id'],
  najechaniu: ['pl'],
  nakala: ['sw'],
  nakili: ['sw'],
  nang: ['tl'],
  nasa: ['sw'],
  nascondere: ['it'],
  nastepnie: ['pl'],
  następnie: ['pl'],
  navegar: ['es', 'pt'],
  navigare: ['it'],
  navigasi: ['id'],
  navigieren: ['de'],
  naviguer: ['fr'],
  nawiguj: ['pl'],
  ñawpachiy: ['qu'],
  ñawpaq: ['qu'],
  ñawpaq_kaq: ['qu'],
  ndani: ['sw'],
  ne: ['tr'],
  nehmen: ['de'],
  ném: ['vi'],
  nenda: ['sw'],
  nenhum: ['pt'],
  nerede: ['tr'],
  nessun: ['it'],
  nếu: ['vi'],
  'nếu không': ['vi'],
  ngắt: ['vi'],
  ngoja: ['sw'],
  'nguồn sự kiện': ['vi'],
  nhận: ['vi'],
  'nhân bản': ['vi'],
  nhấp: ['vi'],
  nhập: ['vi'],
  'nhập liệu': ['vi'],
  ni: ['tr', 'sw'],
  nin: ['tr'],
  ningún: ['es'],
  ñitiy: ['qu'],
  niy: ['qu'],
  nı: ['tr'],
  nın: ['tr'],
  no: ['es'],
  nối: ['vi'],
  'nói với': ['vi'],
  nộp: ['vi'],
  nu: ['tr'],
  nü: ['tr'],
  'nukta-simama': ['sw'],
  nun: ['tr'],
  nün: ['tr'],
  o: ['es'],
  ở_đâu: ['vi'],
  'ổ-cắm': ['vi'],
  obtén: ['es'],
  obtener: ['es'],
  obtenha: ['pt'],
  obtenir: ['fr'],
  obter: ['pt'],
  obtiens: ['fr'],
  ocultar: ['es', 'pt'],
  od: ['pl'],
  odak: ['tr'],
  'odak kaybi': ['tr'],
  'odak kaybı': ['tr'],
  odaklanma: ['tr'],
  odskup: ['pl'],
  oeffnen: ['de'],
  öffnen: ['de'],
  okresl: ['pl'],
  określ: ['pl'],
  olah: ['id'],
  olay: ['tr'],
  'olay-kaynağı': ['tr'],
  ölç: ['tr'],
  olduğunda: ['tr'],
  on: ['en'],
  'ổn định': ['vi'],
  önce: ['tr'],
  onde: ['pt'],
  ondoa: ['sw'],
  ongeza: ['sw'],
  ongezeko: ['sw'],
  onyesha: ['sw'],
  open: ['en'],
  oproznij: ['pl'],
  opróżnij: ['pl'],
  oraz: ['pl'],
  ottenere: ['it'],
  otworz: ['pl'],
  otwórz: ['pl'],
  où: ['fr'],
  ouvrir: ['fr'],
  "p'akiy": ['qu'],
  pa: ['qu'],
  pada: ['id', 'ms'],
  padam: ['ms'],
  padrão: ['pt'],
  padre: ['es'],
  pagkatapos: ['tl'],
  pakakuy: ['qu'],
  pakay: ['qu'],
  pakia: ['sw'],
  palitan: ['tl'],
  palitan_pwesto: ['tl'],
  palitan_url: ['tl'],
  palitawin: ['tl'],
  pamantayan: ['tl'],
  panggil: ['id', 'ms'],
  pangyayari: ['tl'],
  papar: ['ms'],
  paqariy: ['qu'],
  para: ['es', 'pt'],
  para_sa: ['tl'],
  parar: ['es', 'pt'],
  pasang: ['id', 'ms'],
  'pasar por encima': ['es'],
  pasay: ['qu'],
  paskay: ['qu'],
  passaggio: ['it'],
  passar: ['pt'],
  passt: ['de'],
  pasuje: ['pl'],
  pata: ['sw'],
  'paulit-ulit': ['tl'],
  pecah: ['ms'],
  pegar: ['pt'],
  pegue: ['pt'],
  pekerja: ['id', 'ms'],
  peleka: ['sw'],
  pendant: ['fr'],
  penstriman: ['ms'],
  per: ['it'],
  peralihan: ['ms'],
  'perda de foco': ['pt'],
  'perdida de foco': ['es'],
  'pérdida de foco': ['es'],
  pergi: ['id', 'ms'],
  perilaku: ['id'],
  peristiwa: ['id', 'ms'],
  perlihatkan: ['id'],
  permutar: ['es'],
  permuter: ['fr'],
  peroleh: ['id'],
  'perte de focus': ['fr'],
  phát: ['vi'],
  'phát-trực-tiếp': ['vi'],
  phawachiy: ['qu'],
  pi: ['qu'],
  pia: ['sw'],
  pichay: ['qu'],
  pick: ['en'],
  picu: ['id'],
  piepton: ['de'],
  pilih: ['id', 'ms'],
  piliin: ['tl'],
  pima: ['sw'],
  pindah: ['id', 'ms'],
  pintas: ['ms'],
  pisiyachiy: ['qu'],
  pitido: ['es'],
  placer: ['fr'],
  platzieren: ['de'],
  po: ['pl'],
  pobierz: ['pl'],
  poczekaj: ['pl'],
  podczas: ['pl'],
  podłącz: ['pl'],
  poi: ['it'],
  'point-arret': ['fr'],
  'point-arrêt': ['fr'],
  pokaz: ['pl'],
  pokaż: ['pl'],
  pokea: ['sw'],
  połącz: ['pl'],
  pon: ['es'],
  poner: ['es'],
  'ponto-interrupcao': ['pt'],
  'ponto-interrupção': ['pt'],
  poprzedz: ['pl'],
  poprzedź: ['pl'],
  por: ['pt'],
  pôr: ['pt'],
  'por defecto': ['es'],
  potem: ['pl'],
  pour: ['fr'],
  pousser: ['fr'],
  powiąż: ['pl'],
  powiedz: ['pl'],
  powtorz: ['pl'],
  powtórz: ['pl'],
  pracownik: ['pl'],
  preceder: ['pt'],
  predefinito: ['it'],
  predeterminar: ['es'],
  préfixer: ['fr'],
  prendere: ['it'],
  prendre: ['fr'],
  prepend: ['en'],
  presa: ['it'],
  prima: ['it'],
  primera: ['es'],
  primero: ['es'],
  procesar: ['es'],
  process: ['en'],
  processar: ['pt'],
  processare: ['it'],
  proses: ['id', 'ms'],
  proseso: ['tl'],
  protokollieren: ['de'],
  przechwyć: ['pl'],
  przechwytuj: ['pl'],
  przed: ['pl'],
  przejdz: ['pl'],
  przejdź: ['pl'],
  przejscie: ['pl'],
  przejście: ['pl'],
  przeksztalc: ['pl'],
  przekształć: ['pl'],
  przelacz: ['pl'],
  przełącz: ['pl'],
  przerwij: ['pl'],
  przetworz: ['pl'],
  przetwórz: ['pl'],
  przewin: ['pl'],
  przewiń: ['pl'],
  przy: ['pl'],
  puchukay: ['qu'],
  puis: ['fr'],
  pulang: ['ms'],
  pumili: ['tl'],
  pumunta: ['tl'],
  punguza: ['sw'],
  'punkt-przerwania': ['pl'],
  punta: ['tl'],
  'punto-interrupcion': ['es'],
  'punto-interrupción': ['es'],
  'punto-interruzione': ['it'],
  puriy: ['qu'],
  push: ['en', 'es', 'pt', 'de', 'it', 'tr', 'id', 'vi', 'pl', 'sw', 'ms'],
  pusty: ['pl'],
  put: ['en'],
  putulin: ['tl'],
  putuskan: ['id'],
  qallarichiy: ['qu'],
  qallariy: ['qu'],
  qatichiy: ['qu'],
  qatipay: ['qu'],
  qawachiy: ['qu'],
  qayay: ['qu'],
  qhawachiy: ['qu'],
  qhaway: ['qu'],
  qhipa: ['qu'],
  qhipaman_yapay: ['qu'],
  qichuy: ['qu'],
  qillqakuy: ['qu'],
  qillqay: ['qu'],
  quand: ['fr'],
  quando: ['pt', 'it'],
  quindi: ['it'],
  quitar: ['es'],
  'ràng buộc': ['vi'],
  rantikunakuy: ['qu'],
  rantin_tikray: ['qu'],
  'rato libertado': ['pt'],
  'rato pressionado': ['pt'],
  'raton abajo': ['es'],
  'ratón abajo': ['es'],
  'raton arriba': ['es'],
  'ratón arriba': ['es'],
  'raton encima': ['es'],
  'ratón encima': ['es'],
  'raton fuera': ['es'],
  'ratón fuera': ['es'],
  'raton pulsado': ['es'],
  'ratón pulsado': ['es'],
  'raton soltado': ['es'],
  'ratón soltado': ['es'],
  ratónabajo: ['es'],
  ratónarriba: ['es'],
  'rê chuột': ['vi'],
  recolocar: ['pt'],
  recuperar: ['es'],
  recuperare: ['it'],
  récupère: ['fr'],
  récupérer: ['fr'],
  redefinir: ['pt'],
  redimensionamento: ['pt'],
  redimensionar: ['es', 'pt'],
  redimensionnement: ['fr'],
  redimensionner: ['fr'],
  reemplazar: ['es'],
  registrar: ['es', 'pt'],
  registrare: ['it'],
  reimpostare: ['it'],
  reiniciar: ['es'],
  reinitialiser: ['fr'],
  réinitialiser: ['fr'],
  rejea: ['sw'],
  rekam: ['id'],
  rekodi: ['sw'],
  relier: ['fr'],
  remova: ['pt'],
  remove: ['en'],
  remover: ['es', 'pt'],
  remplacer: ['fr'],
  render: ['en', 'tr'],
  renderizar: ['es', 'pt'],
  renderizzare: ['it'],
  rendern: ['de'],
  renderuj: ['pl'],
  rendu: ['fr'],
  renvoyer: ['fr'],
  repeat: ['en'],
  répéter: ['fr'],
  repetir: ['es', 'pt'],
  replace: ['en'],
  repor: ['pt'],
  reset: ['en', 'id', 'ms'],
  resetar: ['pt'],
  restablecer: ['es'],
  retire: ['fr'],
  retirer: ['fr'],
  retornar: ['es', 'pt'],
  retourner: ['fr'],
  return: ['en'],
  ridimensiona: ['it'],
  rikuchiy: ['qu'],
  rikurichiy: ['qu'],
  rimuovere: ['it'],
  ripetere: ['it'],
  ritornare: ['it'],
  riy: ['qu'],
  rồi: ['vi'],
  rolagem: ['pt'],
  rolar: ['pt'],
  romper: ['es'],
  rozmyj: ['pl'],
  rudia: ['sw'],
  rudisha: ['sw'],
  rudufu: ['sw'],
  rurariy: ['qu'],
  ruray: ['qu'],
  ruwakuq: ['qu'],
  ruwana: ['qu'],
  rzuc: ['pl'],
  rzuć: ['pl'],
  sa: ['tl'],
  saat: ['id'],
  sabay: ['tl'],
  sabihin: ['tl'],
  sabitlen: ['tr'],
  sacar: ['es'],
  safisha: ['sw'],
  sagen: ['de'],
  sair: ['pt'],
  saisie: ['fr'],
  saka: ['tl'],
  sakinisha: ['sw'],
  salin: ['id', 'ms'],
  salir: ['es'],
  salvo: ['es', 'pt', 'it'],
  sambung: ['ms'],
  sambungkan: ['id'],
  sampai: ['id', 'ms'],
  'sao chép': ['vi'],
  sapankaq: ['qu'],
  sau: ['vi'],
  'sau đó': ['vi'],
  'sau khi': ['vi'],
  saufsi: ['fr'],
  sayachinay: ['qu'],
  sayay: ['qu'],
  scambiare: ['it'],
  scatenare: ['it'],
  scegliere: ['it'],
  schicken: ['de'],
  schliessen: ['de'],
  schließen: ['de'],
  schowaj: ['pl'],
  schweben: ['de'],
  scorrere: ['it'],
  scroll: ['en', 'pt', 'it', 'ms', 'tl'],
  scrollen: ['de'],
  se: ['pt', 'it'],
  sebelum: ['id', 'ms'],
  seç: ['tr'],
  sehingga: ['ms'],
  'şekil değiştir': ['tr'],
  selagi: ['ms'],
  selainnya: ['id'],
  selama: ['id'],
  selamanya: ['ms'],
  seleccionar: ['es'],
  selecionar: ['pt'],
  select: ['en'],
  selectionner: ['fr'],
  sélectionner: ['fr'],
  selepas: ['ms'],
  selesai: ['id', 'ms'],
  selezionare: ['it'],
  sema: ['sw'],
  semasa: ['ms'],
  sembunyi: ['ms'],
  sembunyikan: ['id'],
  senão: ['pt'],
  send: ['en'],
  senden: ['de'],
  sepadan: ['ms'],
  serta: ['id'],
  sesudah: ['id'],
  set: ['en'],
  'set-semula': ['ms'],
  'setel-ulang': ['id'],
  setelah: ['id'],
  'setelah itu': ['id'],
  seti: ['sw'],
  setkan: ['ms'],
  settle: ['en'],
  setzen: ['de'],
  sfuocare: ['it'],
  show: ['en'],
  shughulikia: ['sw'],
  si: ['es', 'fr'],
  'siaran-langsung': ['ms'],
  sichus: ['qu'],
  sifirla: ['tr'],
  siguiente: ['es'],
  sil: ['tr'],
  simama: ['sw'],
  simulan: ['tl'],
  sino: ['es'],
  sinon: ['fr'],
  sisipkan: ['id'],
  sivyo: ['sw'],
  sıfırla: ['tr'],
  sklonuj: ['pl'],
  skrol: ['ms'],
  skroli: ['sw'],
  skup: ['pl'],
  skupienie: ['pl'],
  sobre: ['es'],
  sobrevoar: ['pt'],
  sobrevolar: ['es'],
  socket: ['en', 'es', 'fr', 'de', 'it', 'zh', 'id', 'ru', 'th', 'vi', 'pl', 'uk', 'he', 'tl'],
  sofern: ['de'],
  sogeza: ['sw'],
  soket: ['tr', 'id', 'ms'],
  soketi: ['sw'],
  'soketi-wavuti': ['sw'],
  solange: ['de'],
  someter: ['es'],
  son: ['tr'],
  sonra: ['tr'],
  sonst: ['de'],
  soquete: ['pt'],
  'sorgente-eventi': ['it'],
  sorok: ['ms'],
  sortir: ['fr'],
  sorvolo: ['it'],
  sostituire: ['it'],
  sottomettere: ['it'],
  soumettre: ['fr'],
  soumission: ['fr'],
  'source-d-evenements': ['fr'],
  sowie: ['de'],
  söyle: ['tr'],
  spingere: ['it'],
  stabiliser: ['fr'],
  stabilisieren: ['de'],
  stabilizzare: ['it'],
  stabilkan: ['id'],
  standard: ['de'],
  stellen: ['de'],
  stop: ['pl'],
  stoppen: ['de'],
  stopper: ['fr'],
  stream: ['en', 'de', 'tl'],
  streaming: ['fr', 'it', 'id'],
  streamuj: ['pl'],
  strim: ['ms'],
  strimu: ['sw'],
  strom: ['de'],
  strumień: ['pl'],
  stworz: ['pl'],
  stwórz: ['pl'],
  su: ['it'],
  'sự kiện': ['vi'],
  subiri: ['sw'],
  submeter: ['pt'],
  submissão: ['pt'],
  submit: ['pl'],
  substituir: ['pt'],
  sukatin: ['tl'],
  sukuma: ['sw'],
  'sumber peristiwa': ['id'],
  sumber_peristiwa: ['ms'],
  supprimer: ['fr'],
  sur: ['fr'],
  süresince: ['tr'],
  sururichiy: ['qu'],
  survol: ['fr'],
  survoler: ['fr'],
  sustituir: ['es'],
  suyay: ['qu'],
  svuotare: ['it'],
  swap: ['en'],
  sygnał: ['pl'],
  "t'ikray": ['qu'],
  "t'inkuy": ['qu'],
  "t'oqo": ['qu'],
  ta: ['tr', 'qu'],
  taasan: ['tl'],
  tabia: ['sw'],
  tải: ['vi'],
  tak_segerak: ['ms'],
  takas: ['tr'],
  take: ['en'],
  tamat: ['id', 'ms'],
  tamati: ['sw'],
  tambah: ['id', 'ms'],
  tambah_hujung: ['ms'],
  tambah_mula: ['ms'],
  tambah_satu: ['ms'],
  tambahkan: ['id'],
  também: ['pt'],
  también: ['es'],
  tampilkan: ['id'],
  tan: ['tr'],
  tandai: ['id', 'ms'],
  tăng: ['vi'],
  'tăng lên': ['vi'],
  tanggalin: ['tl'],
  tangkap: ['id'],
  tanguliza: ['sw'],
  tanqay: ['qu'],
  tạo: ['vi'],
  'tập trung': ['vi'],
  tapos: ['tl'],
  taripakaramuy: ['qu'],
  taripay: ['qu'],
  tarpuy: ['qu'],
  taruh: ['id'],
  tatal: ['ms'],
  tauschen: ['de'],
  tawagan: ['tl'],
  tawagin: ['tl'],
  tẩy: ['vi'],
  te: ['tr'],
  'tecla abajo': ['es'],
  'tecla arriba': ['es'],
  'tecla liberada': ['es'],
  'tecla presionada': ['es'],
  'tecla pulsada': ['es'],
  'tecla soltada': ['es'],
  tekan: ['id'],
  tekrarla: ['tr'],
  tell: ['en'],
  temizle: ['tr'],
  ten: ['tr'],
  tengeneza: ['sw'],
  terminar: ['es'],
  terminer: ['fr'],
  término: ['pt'],
  terus: ['id'],
  teruskan: ['ms'],
  tetapkan: ['id', 'ms'],
  tetikle: ['tr'],
  'thay đổi': ['vi'],
  thay_the: ['vi'],
  thay_thế: ['vi'],
  thêm: ['vi'],
  'thêm vào đầu': ['vi'],
  then: ['en'],
  thì: ['vi'],
  'thiết lập': ['vi'],
  thoát: ['vi'],
  'thoát ra': ['vi'],
  throw: ['en'],
  tia: ['sw'],
  tiada: ['ms'],
  'tiếp tục': ['vi'],
  tik: ['tr'],
  tiklama: ['tr'],
  tikray: ['qu'],
  tikray_url: ['qu'],
  tingkatkan: ['id'],
  tinkina: ['qu'],
  tinkiy: ['qu'],
  'tinkiy-tinkina': ['qu'],
  tiririsha: ['sw'],
  tiru: ['id'],
  'titik-henti': ['id', 'ms'],
  tiyachiy: ['qu'],
  tiyakuy: ['qu'],
  tiyan: ['qu'],
  tık: ['tr'],
  tıkla: ['tr'],
  tıklama: ['tr'],
  to: ['en'],
  toa: ['sw'],
  'toa-kila-kitu': ['sw'],
  toggle: ['en', 'es'],
  togliere: ['it'],
  togol: ['ms'],
  toka: ['sw'],
  tolak: ['ms'],
  tomar: ['es'],
  'trả về': ['vi'],
  trabajador: ['es'],
  trabalhador: ['pt'],
  traiter: ['fr'],
  transformar: ['es', 'pt'],
  transformasi: ['id'],
  transformer: ['fr'],
  transformieren: ['de'],
  transição: ['pt'],
  transición: ['es'],
  transisi: ['id'],
  transition: ['en', 'fr'],
  transizione: ['it'],
  transmitir: ['es', 'pt'],
  transmituj: ['pl'],
  trasformare: ['it'],
  trasmettere: ['it'],
  travailleur: ['fr'],
  trên: ['vi'],
  trigger: ['en'],
  trocar: ['pt'],
  trống: ['vi'],
  'trong khi': ['vi'],
  'trừ khi': ['vi'],
  trừ_khi: ['vi'],
  'trực-tiếp': ['vi'],
  trước: ['vi'],
  'trước khi': ['vi'],
  'truyền-phát': ['vi'],
  từ: ['vi'],
  tukar: ['id', 'ms'],
  tukar_tempat: ['ms'],
  tukio: ['sw'],
  tukukuy: ['qu'],
  tukunay: ['qu'],
  tukurikun: ['qu'],
  tukuy: ['qu'],
  tulia: ['sw'],
  tuma: ['sw'],
  tumawag: ['tl'],
  tumutugma: ['tl'],
  tundu: ['sw'],
  tunggu: ['id', 'ms'],
  tunjuk: ['ms'],
  tunog: ['tl'],
  tupa: ['sw'],
  tupan: ['qu'],
  tupu: ['sw'],
  tupuy: ['qu'],
  turunkan: ['id'],
  tut: ['tr'],
  tutup: ['id', 'ms'],
  tutupkan: ['id'],
  tuwing: ['tl'],
  tuwiran: ['tl'],
  u: ['tr'],
  ü: ['tr'],
  ubah: ['id'],
  ubah_bentuk: ['ms'],
  übergang: ['de'],
  ugali: ['tl'],
  ukryj: ['pl'],
  ukuman: ['qu'],
  ukur: ['id', 'ms'],
  ulang: ['ms'],
  ulangi: ['id'],
  ulitin: ['tl'],
  ultima: ['es'],
  último: ['es'],
  umiesc: ['pl'],
  umieść: ['pl'],
  umschalten: ['de'],
  un: ['tr'],
  ün: ['tr'],
  unang_halaga: ['tl'],
  unapo: ['sw'],
  und: ['de'],
  unda: ['sw'],
  unga: ['sw'],
  ungana: ['sw'],
  unganisha: ['sw'],
  unless: ['th'],
  unterbrechen: ['de'],
  until: ['en'],
  untuk: ['id', 'ms'],
  uscire: ['it'],
  using: ['en'],
  ustabilizuj: ['pl'],
  ustaw: ['pl'],
  usun: ['pl'],
  usuń: ['pl'],
  utworz: ['pl'],
  utwórz: ['pl'],
  üzerinde: ['tr'],
  'üzerinde gezinme': ['tr'],
  'üzerine gelme': ['tr'],
  uzyskaj: ['pl'],
  va: ['fr'],
  vá: ['pt'],
  và: ['vi'],
  vacio: ['es'],
  vacío: ['es'],
  vai: ['it'],
  vào: ['vi'],
  'vào trong': ['vi'],
  varsayılan: ['tr'],
  vazio: ['pt'],
  ve: ['es', 'tr'],
  verarbeiten: ['de'],
  verbergen: ['de'],
  verbinden: ['de'],
  verbindung: ['de'],
  verhalten: ['de'],
  verknuepfen: ['de'],
  verlassen: ['de'],
  vermindern: ['de'],
  verringern: ['de'],
  verstecken: ['de'],
  vertauschen: ['de'],
  verwandeln: ['de'],
  veya: ['tr'],
  via: ['en'],
  vide: ['fr'],
  vider: ['fr'],
  vif: ['fr'],
  vilevile: ['sw'],
  vincolare: ['it'],
  vincular: ['es', 'pt'],
  vinginevyo: ['sw'],
  visualizzare: ['it'],
  vivo: ['es', 'pt', 'it'],
  với: ['vi'],
  'với mỗi': ['vi'],
  von: ['de'],
  vor: ['de'],
  voranstellen: ['de'],
  vunja: ['sw'],
  vuoto: ['it'],
  vurgula: ['tr'],
  w: ['pl'],
  während: ['de'],
  wait: ['en'],
  wakas: ['tl'],
  wakati: ['sw'],
  walang_laman: ['tl'],
  'walang-laman': ['tl'],
  wan: ['qu'],
  wapi: ['sw'],
  waqay: ['qu'],
  waqyay: ['qu'],
  warten: ['de'],
  watachiy: ['qu'],
  watay: ['qu'],
  websocket: [
    'en',
    'es',
    'pt',
    'fr',
    'de',
    'it',
    'ja',
    'zh',
    'ko',
    'ar',
    'tr',
    'id',
    'ru',
    'th',
    'vi',
    'pl',
    'uk',
    'ms',
    'tl',
  ],
  wechseln: ['de'],
  weiter: ['de'],
  wejście: ['pl'],
  weka: ['sw'],
  wenn: ['de'],
  wennnicht: ['de'],
  wepchnij: ['pl'],
  werfen: ['de'],
  wez: ['pl'],
  weź: ['pl'],
  when: ['en'],
  where: ['en'],
  while: ['en'],
  wichqay: ['qu'],
  wiederholen: ['de'],
  willakuy: ['qu'],
  with: ['en'],
  wo: ['de'],
  worker: [
    'en',
    'es',
    'pt',
    'fr',
    'de',
    'it',
    'ja',
    'zh',
    'ko',
    'ar',
    'tr',
    'id',
    'ru',
    'hi',
    'bn',
    'th',
    'vi',
    'pl',
    'uk',
    'sw',
    'qu',
    'he',
    'ms',
    'tl',
  ],
  wpp: ['pl'],
  wprowadzeniu: ['pl'],
  wstaw: ['pl'],
  wtedy: ['pl'],
  wujud: ['ms'],
  wybierz: ['pl'],
  wyczysc: ['pl'],
  wyczyść: ['pl'],
  wyjdź: ['pl'],
  wypisz: ['pl'],
  wyslaniu: ['pl'],
  wysłaniu: ['pl'],
  wyslij: ['pl'],
  wyślij: ['pl'],
  wyswietl: ['pl'],
  wyświetl: ['pl'],
  wywolaj: ['pl'],
  wywołaj: ['pl'],
  wyzwol: ['pl'],
  wyzwól: ['pl'],
  xóa: ['vi'],
  xu_ly: ['vi'],
  xử_lý: ['vi'],
  y: ['es'],
  ya: ['tr'],
  yakala: ['tr'],
  yap: ['tr'],
  yapachiy: ['qu'],
  yapay: ['qu'],
  yapaykuy: ['qu'],
  yayınla: ['tr'],
  yaykuchiy: ['qu'],
  ye: ['tr'],
  yi: ['tr'],
  yı: ['tr'],
  yla: ['tr'],
  yle: ['tr'],
  yok: ['tr'],
  yoksa: ['tr'],
  yu: ['tr'],
  yü: ['tr'],
  yükle: ['tr'],
  yüklemek: ['tr'],
  z: ['pl'],
  zachowanie: ['pl'],
  zainstaluj: ['pl'],
  zaladuj: ['pl'],
  załaduj: ['pl'],
  zaman: ['tr'],
  zamien: ['pl'],
  zamień: ['pl'],
  zamien_url: ['pl'],
  zamień_url: ['pl'],
  zamknij: ['pl'],
  zatrzymaj: ['pl'],
  zaznacz: ['pl'],
  zdarzenie: ['pl'],
  ze: ['pl'],
  zeigen: ['de'],
  zeruj: ['pl'],
  zmiana: ['pl'],
  'zmiana rozmiaru': ['pl'],
  zmianie: ['pl'],
  'zmień rozmiar': ['pl'],
  zmienia: ['pl'],
  zmieńrozmiar: ['pl'],
  zmierz: ['pl'],
  zmniejsz: ['pl'],
  zresetuj: ['pl'],
  'źródło-zdarzeń': ['pl'],
  zu: ['de'],
  zuia: ['sw'],
  zurückgeben: ['de'],
  zurücksetzen: ['de'],
  zuruecksetzen: ['de'],
  związać: ['pl'],
  zwieksz: ['pl'],
  zwiększ: ['pl'],
  zwroc: ['pl'],
  zwróć: ['pl'],
  żywy: ['pl'],
  анимировать: ['ru'],
  анимируй: ['ru'],
  анімувати: ['uk'],
  анімуй: ['uk'],
  асинхронно: ['ru', 'uk'],
  бросить: ['ru'],
  брось: ['ru'],
  в: ['ru', 'uk'],
  'в-прямом-эфире': ['ru'],
  'в-режимі-реального-часу': ['uk'],
  введенні: ['uk'],
  введення: ['uk'],
  ввод: ['ru'],
  вводе: ['ru'],
  верни: ['ru'],
  вернуть: ['ru'],
  вживую: ['ru'],
  взяти: ['uk'],
  взять: ['ru'],
  вибрати: ['uk'],
  видали: ['uk'],
  видалити: ['uk'],
  виділити: ['uk'],
  вийти: ['uk'],
  викликати: ['uk'],
  виклич: ['uk'],
  виміряй: ['uk'],
  виміряти: ['uk'],
  від: ['uk'],
  відкрити: ['uk'],
  відобразити: ['uk'],
  відповідає: ['uk'],
  відправка: ['uk'],
  відправці: ['uk'],
  візьми: ['uk'],
  во: ['ru'],
  возьми: ['ru'],
  воркер: ['ru', 'uk'],
  всегда: ['ru'],
  встав: ['uk'],
  вставити: ['uk'],
  вставить: ['ru'],
  вставь: ['ru'],
  встанови: ['uk'],
  встановити: ['uk'],
  втолкнуть: ['ru'],
  выбрать: ['ru'],
  выделить: ['ru'],
  вызвать: ['ru'],
  вызови: ['ru'],
  выйти: ['ru'],
  где: ['ru'],
  гнездо: ['ru'],
  гніздо: ['uk'],
  далі: ['uk'],
  де: ['uk'],
  'джерело-подій': ['uk'],
  для: ['ru', 'uk'],
  до: ['ru', 'uk'],
  добавить: ['ru'],
  'добавить в конец': ['ru'],
  'добавить в начало': ['ru'],
  добавить_в_конец: ['ru'],
  добавить_в_начало: ['ru'],
  добавь: ['ru'],
  додай: ['uk'],
  додати: ['uk'],
  'додати в кінець': ['uk'],
  'додати на початок': ['uk'],
  додати_в_кінець: ['uk'],
  додати_на_початок: ['uk'],
  дописати: ['uk'],
  дописать: ['ru'],
  если: ['ru'],
  есть: ['ru'],
  є: ['uk'],
  ждать: ['ru'],
  жди: ['ru'],
  живий: ['uk'],
  живой: ['ru'],
  з: ['uk'],
  зʼєднати: ['uk'],
  за_замовчуванням: ['uk'],
  завантаж: ['uk'],
  завантаження: ['uk'],
  завантажити: ['uk'],
  завжди: ['uk'],
  загрузи: ['ru'],
  загрузить: ['ru'],
  загрузка: ['ru'],
  загрузке: ['ru'],
  задай: ['ru', 'uk'],
  задати: ['uk'],
  задать: ['ru'],
  закрити: ['uk'],
  закрыть: ['ru'],
  замени: ['ru'],
  заменить: ['ru'],
  заміни: ['uk'],
  замінити: ['uk'],
  записати: ['uk'],
  записать: ['ru'],
  запиши: ['ru', 'uk'],
  запусти: ['ru', 'uk'],
  запустити: ['uk'],
  запустить: ['ru'],
  затем: ['ru'],
  зачекай: ['uk'],
  заштовхнути: ['uk'],
  збільш: ['uk'],
  збільшити: ['uk'],
  "зв'язати": ['uk'],
  звук: ['ru', 'uk'],
  зменш: ['uk'],
  зменшити: ['uk'],
  зміна: ['uk'],
  зміні: ['uk'],
  змінюється: ['uk'],
  зупинись: ['uk'],
  зупинити: ['uk'],
  и: ['ru'],
  иди: ['ru'],
  идти: ['ru'],
  из: ['ru'],
  изменение: ['ru'],
  изменении: ['ru'],
  изменяется: ['ru'],
  измерить: ['ru'],
  измерь: ['ru'],
  иначе: ['ru'],
  инициализировать: ['ru'],
  инициализируй: ['ru'],
  инициировать: ['ru'],
  инсталлировать: ['ru'],
  'источник-событий': ['ru'],
  і: ['uk'],
  із: ['uk'],
  інакше: ['uk'],
  ініціалізувати: ['uk'],
  ініціалізуй: ['uk'],
  ініціювати: ['uk'],
  інсталювати: ['uk'],
  існує: ['uk'],
  йди: ['uk'],
  йти: ['uk'],
  к: ['ru'],
  каждый: ['ru'],
  кинути: ['uk'],
  кинь: ['uk'],
  кінець: ['uk'],
  клик: ['ru'],
  клике: ['ru'],
  клік: ['uk'],
  кліку: ['uk'],
  клонировать: ['ru'],
  клонируй: ['ru'],
  клонувати: ['uk'],
  клонуй: ['uk'],
  когда: ['ru'],
  кожний: ['uk'],
  коли: ['uk'],
  конец: ['ru'],
  копировать: ['ru'],
  копіювати: ['uk'],
  крім: ['uk'],
  кроме: ['ru'],
  на: ['ru', 'uk'],
  наведение: ['ru'],
  наведении: ['ru'],
  наведенні: ['uk'],
  наведення: ['uk'],
  надіслати: ['uk'],
  надішли: ['uk'],
  надсилання: ['uk'],
  нажатии: ['ru'],
  наживо: ['uk'],
  натисканні: ['uk'],
  нет: ['ru'],
  ні: ['uk'],
  обработай: ['ru'],
  обработать: ['ru'],
  обробити: ['uk'],
  обробляти: ['uk'],
  опустошить: ['ru'],
  остановись: ['ru'],
  остановить: ['ru'],
  от: ['ru'],
  открыть: ['ru'],
  отобразить: ['ru'],
  отправить: ['ru'],
  отправка: ['ru'],
  отправке: ['ru'],
  отправь: ['ru'],
  отримай: ['uk'],
  отримати: ['uk'],
  очистити: ['uk'],
  очистить: ['ru'],
  перед: ['ru', 'uk'],
  перейди: ['ru', 'uk'],
  перейти: ['ru', 'uk'],
  переключи: ['ru'],
  переключить: ['ru'],
  перемкни: ['uk'],
  перемкнути: ['uk'],
  перервати: ['uk'],
  перехвати: ['ru'],
  перехватить: ['ru'],
  перехопити: ['uk'],
  перехоплення: ['uk'],
  підключити: ['uk'],
  підключитися: ['uk'],
  після: ['uk'],
  по_умолчанию: ['ru'],
  поведение: ['ru'],
  поведінка: ['uk'],
  поверни: ['uk'],
  повернути: ['uk'],
  повтори: ['ru', 'uk'],
  повторити: ['uk'],
  повторить: ['ru'],
  подія: ['uk'],
  подключить: ['ru'],
  подключиться: ['ru'],
  подожди: ['ru'],
  пока: ['ru'],
  пока_не: ['ru'],
  покажи: ['ru', 'uk'],
  показати: ['uk'],
  показать: ['ru'],
  поки: ['uk'],
  поки_не: ['uk'],
  поклади: ['uk'],
  покласти: ['uk'],
  положи: ['ru'],
  положить: ['ru'],
  получи: ['ru'],
  получить: ['ru'],
  поменяй: ['ru'],
  поменять: ['ru'],
  помести: ['ru'],
  поместить: ['ru'],
  поміняй: ['uk'],
  поміняти: ['uk'],
  помісти: ['uk'],
  помістити: ['uk'],
  порожній: ['uk'],
  после: ['ru'],
  потік: ['uk'],
  потім: ['uk'],
  поток: ['ru'],
  потом: ['ru'],
  прервать: ['ru'],
  при: ['ru', 'uk'],
  прибери: ['uk'],
  прибрати: ['uk'],
  "прив'язати": ['uk'],
  привязать: ['ru'],
  приєднати: ['uk'],
  приховай: ['uk'],
  приховати: ['uk'],
  продовжити: ['uk'],
  продовжуй: ['uk'],
  продолжи: ['ru'],
  продолжить: ['ru'],
  прокрути: ['ru', 'uk'],
  прокрутити: ['uk'],
  прокрутить: ['ru'],
  'прямой-эфир': ['ru'],
  пустой: ['ru'],
  рабочий: ['ru'],
  размой: ['ru'],
  размыть: ['ru'],
  робітник: ['uk'],
  розфокусувати: ['uk'],
  розфокусуй: ['uk'],
  с: ['ru'],
  сбросить: ['ru'],
  связать: ['ru'],
  скажи: ['ru', 'uk'],
  сказати: ['uk'],
  сказать: ['ru'],
  скинути: ['uk'],
  скрой: ['ru'],
  скрыть: ['ru'],
  со: ['ru'],
  событие: ['ru'],
  соединить: ['ru'],
  создай: ['ru'],
  создать: ['ru'],
  сокет: ['ru', 'uk'],
  соответствует: ['ru'],
  спорожнити: ['uk'],
  спрятать: ['ru'],
  спрячь: ['ru'],
  стабилизировать: ['ru'],
  стабілізувати: ['uk'],
  створи: ['uk'],
  створити: ['uk'],
  стоп: ['ru', 'uk'],
  стрим: ['ru'],
  стрім: ['uk'],
  существует: ['ru'],
  сфокусировать: ['ru'],
  сфокусируй: ['ru'],
  сфокусувати: ['uk'],
  сфокусуй: ['uk'],
  сховай: ['uk'],
  сховати: ['uk'],
  та: ['uk'],
  тогда: ['ru'],
  тоді: ['uk'],
  толкнуть: ['ru'],
  'точка-зупинки': ['uk'],
  'точка-останова': ['ru'],
  транслировать: ['ru'],
  транслювати: ['uk'],
  трансформировать: ['ru'],
  трансформируй: ['ru'],
  трансформувати: ['uk'],
  трансформуй: ['uk'],
  у: ['uk'],
  'у-прямому-ефірі': ['uk'],
  убери: ['ru'],
  убрать: ['ru'],
  увеличить: ['ru'],
  увеличь: ['ru'],
  удали: ['ru'],
  удалить: ['ru'],
  уменьши: ['ru'],
  уменьшить: ['ru'],
  установи: ['ru'],
  установить: ['ru'],
  фокус: ['ru', 'uk'],
  чекай: ['uk'],
  чекати: ['uk'],
  штовхнути: ['uk'],
  якщо: ['uk'],
  אגד: ['he'],
  אז: ['he'],
  אחרי: ['he'],
  אחרת: ['he'],
  איפה: ['he'],
  אירוע: ['he'],
  אל: ['he'],
  אלא: ['he'],
  אם: ['he'],
  'אם לא': ['he'],
  אמור: ['he'],
  אסינכרוני: ['he'],
  אפס: ['he'],
  את: ['he'],
  אתחל: ['he'],
  ב: ['he'],
  בזמן: ['he'],
  'בזמן-אמת': ['he'],
  בחר: ['he'],
  ביפ: ['he'],
  'ברירת מחדל': ['he'],
  'ג׳אווהסקריפט': ['he'],
  גלול: ['he'],
  גם: ['he'],
  דחוף: ['he'],
  הבא: ['he'],
  הגדל: ['he'],
  הגדר: ['he'],
  הגשה: ['he'],
  'הדלק כבה': ['he'],
  הוסף: ['he'],
  'הוסף אחד': ['he'],
  'הוסף בהתחלה': ['he'],
  'הוסף בסוף': ['he'],
  'הוסף-להיסטוריה': ['he'],
  הורד: ['he'],
  הזנה: ['he'],
  הזרם: ['he'],
  החבא: ['he'],
  החזר: ['he'],
  החלף: ['he'],
  החלף_כתובת: ['he'],
  היכן: ['he'],
  הכן: ['he'],
  הכנס: ['he'],
  המר: ['he'],
  המשך: ['he'],
  המתן: ['he'],
  הנח: ['he'],
  הנפש: ['he'],
  הסר: ['he'],
  'הסר מיקוד': ['he'],
  הסתר: ['he'],
  העתק: ['he'],
  הפוך: ['he'],
  הפחת: ['he'],
  הפסק: ['he'],
  הפעל: ['he'],
  הצג: ['he'],
  הקדם: ['he'],
  הקטן: ['he'],
  הראה: ['he'],
  השג: ['he'],
  התחבר: ['he'],
  התחברות: ['he'],
  התחל: ['he'],
  התייצב: ['he'],
  התמקד: ['he'],
  התנהגות: ['he'],
  התקן: ['he'],
  ואז: ['he'],
  וגם: ['he'],
  'ווב-סוקט': ['he'],
  זמן: ['he'],
  זרוק: ['he'],
  חבר: ['he'],
  חזור: ['he'],
  חי: ['he'],
  חכה: ['he'],
  טען: ['he'],
  טשטש: ['he'],
  יירוט: ['he'],
  יירט: ['he'],
  כאשר: ['he'],
  'כל עוד': ['he'],
  כש: ['he'],
  ל: ['he'],
  לחיצה: ['he'],
  לייב: ['he'],
  לך: ['he'],
  לכל: ['he'],
  לפני: ['he'],
  לתוך: ['he'],
  מ: ['he'],
  מאת: ['he'],
  מדוד: ['he'],
  מחק: ['he'],
  מן: ['he'],
  מעבר: ['he'],
  מקד: ['he'],
  'מקור-אירועים': ['he'],
  משתנה: ['he'],
  מתג: ['he'],
  נווט: ['he'],
  נקה: ['he'],
  'נקודת-עצירה': ['he'],
  סגור: ['he'],
  סוף: ['he'],
  סוקט: ['he'],
  סטרים: ['he'],
  סיום: ['he'],
  סמן: ['he'],
  עבד: ['he'],
  עבור: ['he'],
  עד: ['he'],
  עדכון: ['he'],
  עובד: ['he'],
  עיבוד: ['he'],
  על: ['he'],
  עם: ['he'],
  'עצב מחדש': ['he'],
  עצור: ['he'],
  פתח: ['he'],
  צא: ['he'],
  צור: ['he'],
  צרף: ['he'],
  קבל: ['he'],
  קבע: ['he'],
  קח: ['he'],
  קלט: ['he'],
  קליק: ['he'],
  קרא: ['he'],
  קשור: ['he'],
  רוקן: ['he'],
  ריחוף: ['he'],
  רנדר: ['he'],
  רשום: ['he'],
  שבור: ['he'],
  שגר: ['he'],
  שידור: ['he'],
  שים: ['he'],
  שינוי: ['he'],
  שכפל: ['he'],
  שלח: ['he'],
  שליחה: ['he'],
  שנה_כתובת: ['he'],
  שקע: ['he'],
  أخبر: ['ar'],
  أخف: ['ar'],
  أخفِ: ['ar'],
  أرسل: ['ar'],
  أزل: ['ar'],
  أضف: ['ar'],
  أطلق: ['ar'],
  أظهر: ['ar'],
  أعد_تعيين_عنوان: ['ar'],
  'أعد-تعيين': ['ar'],
  أغلق: ['ar'],
  ألحق: ['ar'],
  أنشئ: ['ar'],
  أنقص: ['ar'],
  أوقف: ['ar'],
  أيضاً: ['ar'],
  أين: ['ar'],
  إذا: ['ar'],
  'إعادة-ضبط': ['ar'],
  إفراغ: ['ar'],
  إلا: ['ar'],
  إلى: ['ar'],
  اتصال: ['ar'],
  اتصل: ['ar'],
  اجعل: ['ar'],
  احذف: ['ar'],
  احصل: ['ar'],
  احضر: ['ar'],
  اختر: ['ar'],
  اخرج: ['ar'],
  اخف: ['ar'],
  اخفي: ['ar'],
  ادفع: ['ar'],
  اذهب: ['ar'],
  اربط: ['ar'],
  ارجع: ['ar'],
  ارسم: ['ar'],
  ارفع: ['ar'],
  ارم: ['ar'],
  ارمِ: ['ar'],
  استبدل: ['ar'],
  استبدل_عنوان: ['ar'],
  استدع: ['ar'],
  استقر: ['ar'],
  استنسخ: ['ar'],
  اصنع: ['ar'],
  اضبط: ['ar'],
  اضف: ['ar'],
  اظهر: ['ar'],
  اعتراض: ['ar'],
  اعترض: ['ar'],
  اعرض: ['ar'],
  افتح: ['ar'],
  افتراضي: ['ar'],
  النهاية: ['ar'],
  امسح: ['ar'],
  انتظر: ['ar'],
  انتقال: ['ar'],
  انتقل: ['ar'],
  انتهى: ['ar'],
  انسخ: ['ar'],
  انقص: ['ar'],
  ب: ['ar'],
  بـ: ['ar'],
  باستخدام: ['ar'],
  بث: ['ar'],
  بدء: ['ar'],
  بدل: ['ar'],
  بدّل: ['ar'],
  بعد: ['ar'],
  بعدها: ['ar'],
  بينما: ['ar'],
  تبادل: ['ar'],
  تثبيت: ['ar'],
  تدفق: ['ar'],
  تركيز: ['ar'],
  تشغيل: ['ar'],
  تمرير: ['ar'],
  تهيئة: ['ar'],
  توقف: ['ar'],
  ثبّت: ['ar'],
  ثم: ['ar'],
  ثمّ: ['ar'],
  جافاسكربت: ['ar'],
  جلب: ['ar'],
  حتى: ['ar'],
  حدث: ['ar'],
  حدد: ['ar'],
  حوّل: ['ar'],
  حي: ['ar'],
  حين: ['ar'],
  خذ: ['ar'],
  'خلاف ذلك': ['ar'],
  دفع: ['ar'],
  ربط: ['ar'],
  ركز: ['ar'],
  زد: ['ar'],
  زِد: ['ar'],
  سبق: ['ar'],
  سجل: ['ar'],
  سلوك: ['ar'],
  شوش: ['ar'],
  صفّر: ['ar'],
  ضبابية: ['ar'],
  ضع: ['ar'],
  ظلل: ['ar'],
  عالج: ['ar'],
  عامل: ['ar'],
  عُد: ['ar'],
  على: ['ar'],
  عند: ['ar'],
  عندما: ['ar'],
  عيّن: ['ar'],
  غير: ['ar'],
  غيّر: ['ar'],
  فارغ: ['ar'],
  فعّل: ['ar'],
  في: ['ar'],
  قبل: ['ar'],
  قس: ['ar'],
  قِس: ['ar'],
  قلل: ['ar'],
  قياس: ['ar'],
  كرر: ['ar'],
  'لا يوجد': ['ar'],
  لدى: ['ar'],
  لكل: ['ar'],
  مباشر: ['ar'],
  متزامن: ['ar'],
  مرر: ['ar'],
  'مصدر-الأحداث': ['ar'],
  معالجة: ['ar'],
  مقبس: ['ar'],
  من: ['ar'],
  موجود: ['ar'],
  نادِ: ['ar'],
  نظّف: ['ar'],
  'نقطة-توقف': ['ar'],
  نهاية: ['ar'],
  وأيضاً: ['ar'],
  وإلا: ['ar'],
  واصل: ['ar'],
  يتغير: ['ar'],
  يطابق: ['ar'],
  अगर: ['hi'],
  अंत: ['hi'],
  असिंक: ['hi'],
  इंटरसेप्ट: ['hi'],
  इनपुट: ['hi'],
  इवेंटसोर्स: ['hi'],
  इंस्टॉल: ['hi'],
  ऊपर_रखें: ['hi'],
  और: ['hi'],
  कनेक्ट: ['hi'],
  कहाँ: ['hi'],
  'के बाद': ['hi'],
  'के लिए': ['hi'],
  केंद्रित: ['hi'],
  कॉपी: ['hi'],
  कॉल: ['hi'],
  को: ['hi'],
  'कोई नहीं': ['hi'],
  क्लिक: ['hi'],
  क्लोन: ['hi'],
  खाली: ['hi'],
  'खाली-करें': ['hi'],
  खोलें: ['hi'],
  घटना: ['hi'],
  घटा: ['hi'],
  घटाएं: ['hi'],
  'चिह्नित-करें': ['hi'],
  चुनें: ['hi'],
  छिपा: ['hi'],
  छिपाएं: ['hi'],
  जब: ['hi'],
  'जब तक': ['hi'],
  'जब तक नहीं': ['hi'],
  जमा: ['hi'],
  जा: ['hi'],
  जाएं: ['hi'],
  जारी: ['hi'],
  जेएस: ['hi'],
  जोड़: ['hi'],
  जोड़ें: ['hi'],
  जोड़ें_शुरू: ['hi'],
  टॉगल: ['hi'],
  ट्रिगर: ['hi'],
  डाल: ['hi'],
  डालें: ['hi'],
  डिफ़ॉल्ट: ['hi'],
  तक: ['hi'],
  तब: ['hi'],
  तोड़ें: ['hi'],
  दर्ज: ['hi'],
  दिखा: ['hi'],
  दिखाएं: ['hi'],
  दोहरा: ['hi'],
  दोहराएं: ['hi'],
  धकेलें: ['hi'],
  धारा: ['hi'],
  धुंधला: ['hi'],
  'नहीं तो': ['hi'],
  निर्धारित: ['hi'],
  पर: ['hi'],
  परिवर्तन: ['hi'],
  पहले: ['hi'],
  पाएं: ['hi'],
  पुश: ['hi'],
  प्रतिलिपि: ['hi'],
  प्रतिस्थापित: ['hi'],
  प्रतीक्षा: ['hi'],
  प्रत्यक्ष: ['hi'],
  प्रवाह: ['hi'],
  प्रसंस्कृत: ['hi'],
  प्राप्त: ['hi'],
  प्रारंभ: ['hi'],
  फिर: ['hi'],
  फेंक: ['hi'],
  फेंकें: ['hi'],
  फोकस: ['hi'],
  फोकस_हटाएं: ['hi'],
  बढ़ा: ['hi'],
  बढ़ाएं: ['hi'],
  बता: ['hi'],
  बताएं: ['hi'],
  'बंद-करें': ['hi'],
  बदल: ['hi'],
  'बदलने पर': ['hi'],
  बदलाव: ['hi'],
  बदलें: ['hi'],
  बदलें_यूआरएल: ['hi'],
  बना: ['hi'],
  बनाएं: ['hi'],
  बाइंड: ['hi'],
  बाद: ['hi'],
  बांधें: ['hi'],
  बाहर: ['hi'],
  बीप: ['hi'],
  बुलाएं: ['hi'],
  ब्रेकप्वाइंट: ['hi'],
  भेज: ['hi'],
  भेजें: ['hi'],
  मापें: ['hi'],
  मिटाएं: ['hi'],
  में: ['hi'],
  'मेल खाता': ['hi'],
  मौजूद: ['hi'],
  यदि: ['hi'],
  रख: ['hi'],
  रखें: ['hi'],
  रीसेट: ['hi'],
  रुकें: ['hi'],
  रूपांतर: ['hi'],
  रेंडर: ['hi'],
  रोक: ['hi'],
  रोकें: ['hi'],
  लाइव: ['hi'],
  लाएं: ['hi'],
  ले: ['hi'],
  लें: ['hi'],
  लॉग: ['hi'],
  लौटा: ['hi'],
  लौटाएं: ['hi'],
  वरना: ['hi'],
  वर्कर: ['hi'],
  विनिमय: ['hi'],
  वेबसॉकेट: ['hi'],
  व्यवहार: ['hi'],
  संक्रमण: ['hi'],
  सजीव: ['hi'],
  सबमिट: ['hi'],
  समाप्त: ['hi'],
  संयोजित: ['hi'],
  संलग्न: ['hi'],
  संसाधित: ['hi'],
  'साफ-करें': ['hi'],
  'साफ़-करें': ['hi'],
  से: ['hi'],
  'से पहले': ['hi'],
  सेट: ['hi'],
  सॉकेट: ['hi'],
  स्क्रॉल: ['hi'],
  स्ट्रीम: ['hi'],
  स्थिर: ['hi'],
  हटा: ['hi'],
  हटाएं: ['hi'],
  हमेशा: ['hi'],
  हेतु: ['hi'],
  होवर: ['hi'],
  অপেক্ষা: ['bn'],
  অ্যাসিঙ্ক: ['bn'],
  আগে: ['bn'],
  আচরণ: ['bn'],
  আটকাও: ['bn'],
  আনুন: ['bn'],
  ইনপুট: ['bn'],
  ইনস্টল: ['bn'],
  ইন্টারসেপ্ট: ['bn'],
  ইভেন্টসোর্স: ['bn'],
  উপরে_রাখুন: ['bn'],
  এ: ['bn'],
  এবং: ['bn'],
  ওয়ার্কার: ['bn'],
  ওয়েবসকেট: ['bn'],
  কপি: ['bn'],
  কমান: ['bn'],
  কর্মী: ['bn'],
  কল: ['bn'],
  কানেক্ট: ['bn'],
  কে: ['bn'],
  কোথায়: ['bn'],
  ক্লিক: ['bn'],
  ক্লোন: ['bn'],
  খালি: ['bn'],
  'খালি-করুন': ['bn'],
  খুলুন: ['bn'],
  ঘটনা: ['bn'],
  'চালিয়ে যান': ['bn'],
  চিরকাল: ['bn'],
  'ছুঁড়ে দিন': ['bn'],
  জন্য: ['bn'],
  জমা: ['bn'],
  জুড়ুন: ['bn'],
  জেএস: ['bn'],
  ঝাপসা: ['bn'],
  টগল: ['bn'],
  ট্রিগার: ['bn'],
  ঠেলুন: ['bn'],
  ডাকুন: ['bn'],
  ডিফল্ট: ['bn'],
  তখন: ['bn'],
  তারপর: ['bn'],
  তে: ['bn'],
  'তৈরি করুন': ['bn'],
  থামাও: ['bn'],
  থামুন: ['bn'],
  থেকে: ['bn'],
  দিয়ে: ['bn'],
  দেখাও: ['bn'],
  দেখান: ['bn'],
  নতুবা: ['bn'],
  'না হলে': ['bn'],
  নিক্ষেপ: ['bn'],
  নিন: ['bn'],
  নির্ধারণ: ['bn'],
  নির্বাচন: ['bn'],
  নে: ['bn'],
  পরিবর্তন: ['bn'],
  'পরিবর্তিত হলে': ['bn'],
  পরিষ্কার: ['bn'],
  পরে: ['bn'],
  পর্যন্ত: ['bn'],
  পাঠাও: ['bn'],
  পাঠান: ['bn'],
  পান: ['bn'],
  পুনরাবৃত্তি: ['bn'],
  পুশ: ['bn'],
  প্রক্রিয়া: ['bn'],
  প্রতিলিপি: ['bn'],
  প্রতিস্থাপন: ['bn'],
  প্রত্যক্ষ: ['bn'],
  প্রবাহ: ['bn'],
  প্রবেশ: ['bn'],
  প্রসেস: ['bn'],
  ফিরুন: ['bn'],
  'ফেরত দিন': ['bn'],
  ফোকাস: ['bn'],
  ফোকাস_সরান: ['bn'],
  বদল: ['bn'],
  বন্ধ: ['bn'],
  বল: ['bn'],
  বলুন: ['bn'],
  বাইন্ড: ['bn'],
  বাছুন: ['bn'],
  বাড়ান: ['bn'],
  বানান: ['bn'],
  'বার বার': ['bn'],
  বীপ: ['bn'],
  বৃদ্ধি: ['bn'],
  বের: ['bn'],
  ব্রেকপয়েন্ট: ['bn'],
  ভাঙুন: ['bn'],
  ভিতরে: ['bn'],
  মনোযোগ: ['bn'],
  মাপুন: ['bn'],
  মুছুন: ['bn'],
  যখন: ['bn'],
  যতক্ষণ: ['bn'],
  যদি: ['bn'],
  'যদি না': ['bn'],
  যাও: ['bn'],
  যান: ['bn'],
  যুক্ত: ['bn'],
  যোগ: ['bn'],
  'যোগ করুন': ['bn'],
  রাখ: ['bn'],
  রাখুন: ['bn'],
  রিসেট: ['bn'],
  রূপান্তর: ['bn'],
  রেকর্ড: ['bn'],
  রেন্ডার: ['bn'],
  লগ: ['bn'],
  লাইভ: ['bn'],
  লুকাও: ['bn'],
  লুকান: ['bn'],
  শুরু: ['bn'],
  'শুরুতে যোগ': ['bn'],
  শেষ: ['bn'],
  সকেট: ['bn'],
  সংক্রমণ: ['bn'],
  সমাপ্ত: ['bn'],
  সংযোগ: ['bn'],
  সরান: ['bn'],
  সরাসরি: ['bn'],
  'সরিয়ে ফেলুন': ['bn'],
  সাবমিট: ['bn'],
  সেট: ['bn'],
  স্ক্রোল: ['bn'],
  স্ট্রিম: ['bn'],
  স্থির: ['bn'],
  স্রোত: ['bn'],
  হয়: ['bn'],
  হোভার: ['bn'],
  হ্রাস: ['bn'],
  กรอก: ['th'],
  กระแส: ['th'],
  กลับ: ['th'],
  ก่อน: ['th'],
  กำหนด: ['th'],
  ขณะที่: ['th'],
  ขัดจังหวะ: ['th'],
  คงที่: ['th'],
  คลิก: ['th'],
  คัดลอก: ['th'],
  ค่าเริ่มต้น: ['th'],
  คืนค่า: ['th'],
  เคลียร์: ['th'],
  โคลน: ['th'],
  จนถึง: ['th'],
  จบ: ['th'],
  จัดการ: ['th'],
  จาก: ['th'],
  จุดพัก: ['th'],
  เจเอส: ['th'],
  เชื่อม: ['th'],
  เชื่อมต่อ: ['th'],
  ซ็อกเก็ต: ['th'],
  ซ่อน: ['th'],
  ด้วย: ['th'],
  ดักจับ: ['th'],
  ดัน: ['th'],
  ดึงข้อมูล: ['th'],
  ตลอดไป: ['th'],
  ตอน: ['th'],
  ต่อไป: ['th'],
  ตั้ง: ['th'],
  ติดตั้ง: ['th'],
  ถ้า: ['th'],
  ถ่ายทอดสด: ['th'],
  ทริกเกอร์: ['th'],
  ทำเครื่องหมาย: ['th'],
  ทำซ้ำ: ['th'],
  ทำให้ว่าง: ['th'],
  ที่ไหน: ['th'],
  แทนที่: ['th'],
  ใน: ['th'],
  ในขณะที่: ['th'],
  บอก: ['th'],
  บันทึก: ['th'],
  บี๊บ: ['th'],
  เบลอ: ['th'],
  ประมวลผล: ['th'],
  ป้อน: ['th'],
  ปิด: ['th'],
  เปลี่ยน: ['th'],
  'เปลี่ยน-url': ['th'],
  เปลี่ยนแปลง: ['th'],
  เปลี่ยนผ่าน: ['th'],
  เปิด: ['th'],
  แปลงร่าง: ['th'],
  ไป: ['th'],
  ไปที่: ['th'],
  ไปยัง: ['th'],
  ผลัก: ['th'],
  ผูก: ['th'],
  พฤติกรรม: ['th'],
  เพิ่ม: ['th'],
  เพิ่มค่า: ['th'],
  เพิ่มท้าย: ['th'],
  เพิ่มหน้า: ['th'],
  โฟกัส: ['th'],
  มีอยู่: ['th'],
  เมื่อ: ['th'],
  ไม่งั้น: ['th'],
  ไม่เช่นนั้น: ['th'],
  ยื่น: ['th'],
  โยน: ['th'],
  รอ: ['th'],
  รับ: ['th'],
  รับค่า: ['th'],
  รีเซ็ต: ['th'],
  เริ่มต้น: ['th'],
  เรียก: ['th'],
  ลดค่า: ['th'],
  ลบ: ['th'],
  ลบออก: ['th'],
  ล้าง: ['th'],
  เลือก: ['th'],
  เลื่อน: ['th'],
  แล้ว: ['th'],
  และ: ['th'],
  ไลฟ์: ['th'],
  วัด: ['th'],
  วาง: ['th'],
  ว่าง: ['th'],
  วางเมาส์: ['th'],
  เว็บซ็อกเก็ต: ['th'],
  เวิร์กเกอร์: ['th'],
  สกัดกั้น: ['th'],
  ส่ง: ['th'],
  ส่งข้อมูล: ['th'],
  สด: ['th'],
  สตรีม: ['th'],
  สตรีมมิ่ง: ['th'],
  สร้าง: ['th'],
  สลับ: ['th'],
  สลับที่: ['th'],
  สำเนา: ['th'],
  สำหรับ: ['th'],
  แสดง: ['th'],
  แสดงผล: ['th'],
  ใส่: ['th'],
  หยุด: ['th'],
  หลัง: ['th'],
  หาก: ['th'],
  เหตุการณ์: ['th'],
  ออก: ['th'],
  อะซิงค์: ['th'],
  อีเวนต์ซอร์ส: ['th'],
  โฮเวอร์: ['th'],
  가로채기: ['ko'],
  가져오기: ['ko'],
  가져오다: ['ko'],
  가져오세요: ['ko'],
  각각: ['ko'],
  감소: ['ko'],
  계속: ['ko'],
  고르기: ['ko'],
  교체: ['ko'],
  교환: ['ko'],
  그다음: ['ko'],
  그런후: ['ko'],
  그리고: ['ko'],
  기본값: ['ko'],
  까지: ['ko'],
  끝: ['ko'],
  끝에추가: ['ko'],
  나가기: ['ko'],
  넣기: ['ko'],
  넣다: ['ko'],
  넣으세요: ['ko'],
  놓기: ['ko'],
  닫기: ['ko'],
  대기: ['ko'],
  던지다: ['ko'],
  덧붙이다: ['ko'],
  동안: ['ko'],
  동작: ['ko'],
  때: ['ko'],
  또한: ['ko'],
  라이브: ['ko'],
  렌더링: ['ko'],
  로: ['ko'],
  로그: ['ko'],
  를: ['ko'],
  마침: ['ko'],
  만들다: ['ko'],
  만약: ['ko'],
  말하다: ['ko'],
  및: ['ko'],
  바꾸기: ['ko'],
  바꾸다: ['ko'],
  바인드: ['ko'],
  반복: ['ko'],
  반환: ['ko'],
  변경: ['ko'],
  변경되면: ['ko'],
  변형: ['ko'],
  변환: ['ko'],
  보내다: ['ko'],
  보내세요: ['ko'],
  보이기: ['ko'],
  보이다: ['ko'],
  보이세요: ['ko'],
  복사: ['ko'],
  복제: ['ko'],
  부터: ['ko'],
  블러: ['ko'],
  비동기: ['ko'],
  비어있는: ['ko'],
  비우기: ['ko'],
  비프: ['ko'],
  삭제: ['ko'],
  선두추가: ['ko'],
  선택: ['ko'],
  설정: ['ko'],
  설치: ['ko'],
  소켓: ['ko'],
  숨기기: ['ko'],
  숨기다: ['ko'],
  숨기세요: ['ko'],
  스크롤: ['ko'],
  스트리밍: ['ko'],
  스트림: ['ko'],
  시: ['ko'],
  실시간: ['ko'],
  아니라면: ['ko'],
  아니면: ['ko'],
  안정: ['ko'],
  앞에추가: ['ko'],
  어디: ['ko'],
  얻다: ['ko'],
  얻으세요: ['ko'],
  없음: ['ko'],
  에: ['ko'],
  에서: ['ko'],
  연결: ['ko'],
  열기: ['ko'],
  워커: ['ko'],
  으로: ['ko'],
  을: ['ko'],
  의: ['ko'],
  이동: ['ko'],
  이벤트: ['ko'],
  이벤트소스: ['ko'],
  인터셉트: ['ko'],
  일치: ['ko'],
  입력: ['ko'],
  재설정: ['ko'],
  전에: ['ko'],
  전환: ['ko'],
  접속: ['ko'],
  정지: ['ko'],
  제거: ['ko'],
  제출: ['ko'],
  존재: ['ko'],
  중단: ['ko'],
  중단점: ['ko'],
  증가: ['ko'],
  지우기: ['ko'],
  처리: ['ko'],
  초기화: ['ko'],
  추가: ['ko'],
  측정: ['ko'],
  클릭: ['ko'],
  토글: ['ko'],
  트랜지션: ['ko'],
  트리거: ['ko'],
  패치: ['ko'],
  포커스: ['ko'],
  포커스아웃: ['ko'],
  표시: ['ko'],
  푸시: ['ko'],
  '할 때': ['ko'],
  호버: ['ko'],
  호출: ['ko'],
  후에: ['ko'],
  アシンク: ['ja'],
  アニメーション: ['ja'],
  アペンド: ['ja'],
  イベント: ['ja'],
  イベントソース: ['ja'],
  インクリメント: ['ja'],
  インストール: ['ja'],
  インターセプト: ['ja'],
  オープン: ['ja'],
  おわり: ['ja'],
  から: ['ja'],
  クリア: ['ja'],
  クローズ: ['ja'],
  クローン: ['ja'],
  ゲット: ['ja'],
  コール: ['ja'],
  コピー: ['ja'],
  スクロール: ['ja'],
  ストリーム: ['ja'],
  スロー: ['ja'],
  スワップ: ['ja'],
  セレクト: ['ja'],
  そうでなければ: ['ja'],
  ソケット: ['ja'],
  そして: ['ja'],
  それから: ['ja'],
  それ以外: ['ja'],
  ために: ['ja'],
  で: ['ja'],
  である: ['ja'],
  デクリメント: ['ja'],
  デフォルト: ['ja'],
  テル: ['ja'],
  と: ['ja'],
  とき: ['ja'],
  ときに: ['ja'],
  トグル: ['ja'],
  トグルする: ['ja'],
  どこ: ['ja'],
  トランジション: ['ja'],
  トリガー: ['ja'],
  ない: ['ja'],
  ない限り: ['ja'],
  ナビゲート: ['ja'],
  なら: ['ja'],
  ならば: ['ja'],
  に: ['ja'],
  の: ['ja'],
  の間: ['ja'],
  バインド: ['ja'],
  ハルト: ['ja'],
  ビープ: ['ja'],
  ビヘイビア: ['ja'],
  フェッチ: ['ja'],
  フォーカス: ['ja'],
  フォーカスアウト: ['ja'],
  フォーカス解除: ['ja'],
  プッシュ: ['ja'],
  ブラー: ['ja'],
  プリペンド: ['ja'],
  ブレークポイント: ['ja'],
  へ: ['ja'],
  ぼかし: ['ja'],
  また: ['ja'],
  まで: ['ja'],
  メジャー: ['ja'],
  モーフ: ['ja'],
  もし: ['ja'],
  ライブ: ['ja'],
  リセット: ['ja'],
  リターン: ['ja'],
  リピート: ['ja'],
  ログ: ['ja'],
  ワーカー: ['ja'],
  を: ['ja'],
  一致する: ['ja'],
  中断: ['ja', 'zh'],
  为: ['zh'],
  之前: ['zh'],
  之后: ['zh'],
  事件: ['zh'],
  事件源: ['zh'],
  事象: ['ja'],
  于: ['zh'],
  交换: ['zh'],
  交換: ['ja'],
  从: ['zh'],
  以: ['zh'],
  伝える: ['ja'],
  何时: ['zh'],
  作る: ['ja'],
  作成: ['ja'],
  停止: ['ja', 'zh'],
  傍受: ['ja'],
  先頭に追加: ['ja'],
  先頭追加: ['ja'],
  克隆: ['zh'],
  入れる: ['ja'],
  入れ替え: ['ja'],
  关闭: ['zh'],
  再設定: ['ja'],
  减少: ['zh'],
  処理: ['ja'],
  出力: ['ja'],
  切り替え: ['ja'],
  切り替える: ['ja'],
  切换: ['zh'],
  初始化: ['zh'],
  初期化: ['ja'],
  删除: ['zh'],
  到: ['zh'],
  制作: ['zh'],
  削除: ['ja'],
  削除する: ['ja'],
  前: ['ja'],
  前に: ['ja'],
  前往: ['zh'],
  前置: ['zh'],
  加: ['zh'],
  加える: ['ja'],
  匹配: ['zh'],
  去掉: ['zh'],
  发送: ['zh'],
  取り除く: ['ja'],
  取る: ['ja'],
  取得: ['ja', 'zh'],
  取得する: ['ja'],
  取得焦點: ['zh'],
  变化: ['zh'],
  变形: ['zh'],
  各: ['ja'],
  否则: ['zh'],
  告诉: ['zh'],
  呼び出し: ['ja'],
  呼ぶ: ['ja'],
  和: ['zh'],
  哪里: ['zh'],
  在: ['zh'],
  '在...时': ['zh'],
  増やす: ['ja'],
  増加: ['ja'],
  增加: ['zh'],
  处理: ['zh'],
  変わったら: ['ja'],
  変形: ['ja'],
  変換: ['ja'],
  复制: ['zh'],
  失去焦點: ['zh'],
  失焦: ['zh'],
  套接字: ['zh'],
  如果: ['zh'],
  存在: ['zh'],
  存在する: ['ja'],
  安定: ['ja'],
  安装: ['zh'],
  完: ['zh'],
  实时: ['zh'],
  実時間: ['ja'],
  導入: ['ja'],
  展示: ['zh'],
  工作线程: ['zh'],
  工作者: ['zh'],
  并且: ['zh'],
  异步: ['zh'],
  引き金: ['ja'],
  当: ['zh'],
  待つ: ['ja'],
  待機: ['ja'],
  後: ['ja'],
  後に: ['ja'],
  悬停: ['zh'],
  悬浮: ['zh'],
  戻る: ['ja'],
  打开: ['zh'],
  把: ['zh'],
  抓取: ['zh'],
  投げる: ['ja'],
  抛出: ['zh'],
  拦截: ['zh'],
  拿取: ['zh'],
  持续: ['zh'],
  振る舞い: ['ja'],
  捲動: ['zh'],
  接着: ['zh'],
  接続: ['ja'],
  接続する: ['ja'],
  推送: ['zh'],
  描画: ['ja'],
  提交: ['zh'],
  改变: ['zh'],
  改变时: ['zh'],
  放: ['zh'],
  放入: ['zh'],
  放置: ['zh'],
  断点: ['zh'],
  既定: ['ja'],
  日志: ['zh'],
  显示: ['zh'],
  時: ['ja'],
  替换: ['zh'],
  末尾に追加: ['ja'],
  末尾追加: ['ja'],
  次に: ['ja'],
  止める: ['ja'],
  流: ['zh'],
  流式传输: ['zh'],
  测量: ['zh'],
  消去: ['ja'],
  添加: ['zh'],
  清空: ['zh'],
  清除: ['zh'],
  減らす: ['ja'],
  減少: ['ja'],
  測定: ['ja'],
  渲染: ['zh'],
  滚动: ['zh'],
  点击: ['zh'],
  然后: ['zh'],
  用: ['zh'],
  由: ['zh'],
  発火: ['ja'],
  直到: ['zh'],
  直播: ['zh'],
  移動: ['ja'],
  移除: ['zh'],
  稳定: ['zh'],
  空に: ['ja'],
  空にする: ['ja'],
  空的: ['zh'],
  等待: ['zh'],
  終わり: ['ja'],
  终止: ['zh'],
  結びつける: ['ja'],
  绑定: ['zh'],
  结束: ['zh'],
  継続: ['ja'],
  続ける: ['ja'],
  继续: ['zh'],
  繰り返し: ['ja'],
  繰り返す: ['ja'],
  置き換え: ['ja'],
  置く: ['ja'],
  置換: ['ja'],
  而且: ['zh'],
  聚焦: ['zh'],
  获取: ['zh'],
  获得: ['zh'],
  落ち着く: ['ja'],
  蜂鸣: ['zh'],
  行く: ['ja'],
  行为: ['zh'],
  表示: ['ja'],
  表示する: ['ja'],
  複製: ['ja'],
  見せる: ['ja'],
  触发: ['zh'],
  計測: ['ja'],
  記録: ['ja'],
  設定: ['ja'],
  設定する: ['ja'],
  设定: ['zh'],
  设置: ['zh'],
  调用: ['zh'],
  转换: ['zh'],
  输入: ['zh'],
  迄: ['ja'],
  过渡: ['zh'],
  返す: ['ja'],
  返回: ['zh'],
  进入: ['zh'],
  连接: ['zh'],
  连接器: ['zh'],
  追加: ['ja', 'zh'],
  追加する: ['ja'],
  退出: ['ja', 'zh'],
  送る: ['ja'],
  送信: ['ja'],
  送出: ['zh'],
  选取: ['zh'],
  选择: ['zh'],
  遷移: ['ja'],
  選ぶ: ['ja'],
  選択: ['ja'],
  那么: ['zh'],
  配信: ['ja'],
  重复: ['zh'],
  重置: ['zh'],
  閉じる: ['ja'],
  開く: ['ja'],
  間: ['ja'],
  附加: ['zh'],
  除非: ['zh'],
  隐藏: ['zh'],
  隠す: ['ja'],
  非同期: ['ja'],
  非表示: ['ja'],
  非表示にする: ['ja'],
  预置: ['zh'],
  默认: ['zh'],
};

/**
 * Unicode script ranges for non-Latin script detection.
 * Provides instant language identification for CJK, Arabic, Cyrillic, etc.
 */
export const SCRIPT_RANGES: readonly {
  start: number;
  end: number;
  languages: readonly string[];
}[] = [
  { start: 0x3040, end: 0x309f, languages: ['ja'] },
  { start: 0x30a0, end: 0x30ff, languages: ['ja'] },
  { start: 0x4e00, end: 0x9fff, languages: ['ja', 'zh'] },
  { start: 0xac00, end: 0xd7af, languages: ['ko'] },
  { start: 0x600, end: 0x6ff, languages: ['ar'] },
  { start: 0x590, end: 0x5ff, languages: ['he'] },
  { start: 0x400, end: 0x4ff, languages: ['ru', 'uk'] },
  { start: 0x900, end: 0x97f, languages: ['hi'] },
  { start: 0x980, end: 0x9ff, languages: ['bn'] },
  { start: 0xe00, end: 0xe7f, languages: ['th'] },
];

/**
 * Total keywords: 3329
 * Total languages: 24
 * Ambiguous keywords (match 2+ languages): 197
 */
